/* eslint-disable */
const messages = {
  V: `v`,
  TEAM_ID: `ID: {id}`,
  TEAM_NAME: `Equipo: {name}`,
  DASHBOARD: `Panel`,
  INDICATOR: `Indicador`,
  INDICATORS: `Indicadores`,
  THEME: `Tema`,
  ACTION_PLANS: `Planes de acción`,
  PENDING: `Espera`,
  PROBLEMS: `Problemas`,
  PROBLEMS_SHORT: `Prob.`,
  PROBLEM_SOLVING: `Resolución de problemas`,
  DMP: `Gestión diaria del rendimiento`,
  SYNTHESIS: `Resumen de rutina`,
  STATS: `Estadísticas`,
  INFORMATION: `Información`,
  INFORMATIONS: `Información`,
  INFORMATIONS_SHORT: `Datos`,
  FILTERS: `Filtros`,
  ARCHIVES: `Archivos`,
  SCHEDULE: `Agenda`,
  OPTIONS: `Opciones`,
  PROBLEM: `Problema`,
  NEW_PROBLEM: `Nuevo problema`,
  ADD_PROBLEM: `Añadir un problema`,
  ADD_ACTION: `Añadir una acción`,
  SEARCH: `Búsqueda`,
  SEARCH_PH: `@:(message.SEARCH)…`,
  CAUSES: `Causas`,
  CAUSE: `Causa`,
  CAUSE_DESCRIPTION: `Descripción de la causa`,
  ACTION: `Acción`,
  ACTIONS: `Acciones`,
  ACTION_NAME: `Nombre de la acción`,
  MEETINGS: `Reuniones`,
  MEETINGS_SHORT: `Reu.`,
  LANGUAGE: `Idioma`,
  SUMMARY: `Resumen`,
  CLOSE: `Cerrar`,
  SUBMIT: `Validar`,
  SORT: `Ordenar`,
  TWO_DOTS: ` : `,
  HYPHEN: `-`,
  LOGIN: `Inicio de sesión`,
  SECURE_AUTHENTICATION: `Autenticación segura`,
  CANCEL: `Cancelar`,
  DELETE: `Eliminar`,
  RESTORE: `Restablecer`,
  IGNORE: `Ignorar`,
  TAGS: `Tags`,
  TO_BE_DEFINED: `To be defined`,
  SELECT_COLOR: `Seleccione un color`,
  NONE: `Ninguno`,
  NONE_FEM: `Ninguna`,
  OK: `Ok`,
  GW_OK: `OK`,
  GW_NOK: `NOK`,
  YES: `Sí`,
  NO: `No`,
  REALLY_BAD: `Muy deficiente`,
  BAD: `Mala`,
  NOT_SO_GOOD: `Regular`,
  OKAY: `Aceptable`,
  GOOD: `Buena`,
  EXCELLENT: `Excelente`,
  DUPLICATE: `Duplicar`,
  SEND: `Enviar`,
  SELECT: `Seleccionar`,
  NOT_APPLICABLE_SHORT: `N/A`,
  NOT_APPLICABLE_PARENTHESIS: `(No aplicable)`,
  TEXT_COMMA: ` ,`,
  AND: `y`,
  QUOTE: `"`,
  SEE_MORE: `Ver más`,
  LOAD_MORE: `Cargar más…`,
  EXAMPLE: `Ejemplo`,
  PIXELS: `Píxeles`,
  CHART: `Gráfico`,
  TABLE: `Tabla`,
  CLICK_TOOLTIP_TO_ENLARGE: `Haga clic para ampliar`,
  DECIMAL_POINT: `,`,
  MANUAL_INPUT: `Entrada manual`,
  INDICATOR_OF_MY_TEAM: `Indicador de mi equipo`,
  INDICATOR_OF_OTHER_TEAM: `Indicador de otro equipo`,
  N_MISSING_VALUES: `No falta ningún valor | Falta 1 valor | Faltan {nb} valores`,
  BETA_TAG: `BETA`,
  CONTENT_BETWEEN_PARENTHESES: `({content})`,
  LOGIN_BY_TEAM: `Cuenta de equipo`,
  LOGIN_BY_USER: `Cuenta de usuario`,
  LOGIN_BY_SSO: `Cuenta Single Sign-On`,
  LOGIN_BY_TEAM_SHORT: `@:message.TEAM`,
  LOGIN_BY_USER_SHORT: `@:message.USER`,
  LOGIN_BY_SSO_SHORT: `Single Sign-On`,
  LOGIN_BY_SSO_HINT: `Introduzca su ID de equipo si desea iniciar sesión como equipo O su nombre de usuario si desea hacerlo en su cuenta personal.`,
  LOGIN_TEAM_ID: `ID de equipo`,
  LOGIN_TEAM_ID_EXAMPLE: `ID de equipo (P. ej.: "123456")`,
  LOGIN_USER_ID: `Nombre de usuario`,
  LOGIN_USER_ID_EXAMPLE: `Nombre de usuario (P. ej.: "a.ruiz")`,
  LOGIN_PWD: `Contraseña`,
  LOGIN__COMPANY_PWD: `Contraseña de la empresa`,
  LOGIN_SUBMIT: `Iniciar sesión`,
  STAY_CONNECTED: `No cerrar sesión`,
  FORGOT_PASSWORD: `¿Ha olvidado la contraseña?`,
  NEED_NEW_PWD: `¿Desea recibir una nueva contraseña en la dirección de correo electrónico de su equipo?<br/>La contraseña se modificará para todo el equipo.<br/>Si su equipo no ha configurado una dirección de email válida, la contraseña se enviará a info@shizen.io.<br/><br/>Todos los usuarios que hayan iniciado sesión permanecerán conectados.`,
  NEED_NEW_PWD_USER: `¿Desea recibir una nueva contraseña de usuario?<br/>Si no se ha configurado ninguna dirección de correo electrónico para esta cuenta, la contraseña se enviará a la dirección de correo electrónico de su equipo.<br>Si no está configurada, se enviará a info@shizen.io.`,
  NEW_PWD_TEAM_ID: `ID: (6 o 7 cifras)-(3 letras) sin paréntesis`,
  NEW_PWD_USER_ID: `Introduzca su nombre de usuario`,
  PWD_RESET_SUCCESS: `Su contraseña se ha restablecido. La encontrará en el email que se le ha enviado.`,
  NEW_PWD_WRONG_FORMAT: `El ID que ha introducido no posee el formato requerido: El ID está formado por 6 o 7 cifras seguidas de un guion "-" y de 3 caracteres alfanuméricos.<br/>Por ejemplo: 100753-H7D`,
  NEW_PWD_NO_MATCH: `El ID que ha introducido no corresponde a ninguna cuenta de Shizen. Vuelva a comprobarlo.`,
  SEARCH_PLACEHOLDER: `Búsqueda...`,
  TYPE_IN_SEARCH_FIELD: `Escriba algo en el campo de búsqueda`,
  SEARCHING_DOTS: `Búsqueda...`,
  NO_MATCH_PROBLEMS: `No hay ningún problema que coincida con la búsqueda`,
  NO_MATCH_ACTIONS: `No hay ninguna acción que coincida con la búsqueda`,
  NO_MATCH_GW: `No hay ninguna inspección sobre el terreno que coincida con la búsqueda`,
  NO_MATCH_TEAMS: `No hay ningún equipo que coincida con la búsqueda`,
  SETTINGS: `Ajustes`,
  SETTINGS_SAML: `Ajustes de autenticación por SAML (SSO)`,
  SETTINGS_MAIN: `Ajustes generales`,
  SETTINGS_INDICATORS: `Indicadores`,
  SETTINGS_ACTIONS: `Acciones`,
  SETTINGS_PROBLEMS: `Problemas`,
  SETTINGS_INDICATORS_THEMES: `Indicadores y temas`,
  SETTINGS_DASHBOARD: `Panel`,
  SETTINGS_MEETINGS: `Reuniones`,
  SETTINGS_TEAM: `Detalles de equipo`,
  SETTINGS_GW: `@:message.GEMBA_WALKS`,
  SETTINGS_PAGES: `Páginas de ajustes`,
  ADD_TYPE: `Añadir un tipo`,
  DELETE_SUBTYPES: `¿Desea también eliminar los tipos que contiene?`,
  CUSTOM_PROBLEM_HINTS: `Personalizar las indicaciones de los campos de un problema`,
  CUSTOM_PROBLEM_HINTS_EXPLANATION: `Aquí puede personalizar las indicaciones sugeridas bajo los campos de descripción de un problema durante las notificaciones de problemas.<br>También puede hacer que se muestren estas indicaciones en la ficha de problema.`,
  DISPLAY_PROBLEM_HINT_SHEET: `Mostrar en la ficha de problema`,
  USE_COMPANY_SETTING: `Utilizar el ajuste de la empresa`,
  DEFAULT_HINTS: `Indicaciones predeterminadas`,
  CUSTOM_PROBLEM_HINTS_HOWTO: `Rellene los siguientes campos con el texto que desee que aparezca bajo los campos de notificación de problemas. Si deja algún campo vacío, se mostrará entonces la indicación predeterminada únicamente para ese campo (las indicaciones predeterminadas se muestran a continuación).`,
  ENTER_IMPACT_HINT: `Introduzca el texto que desea mostrar`,
  DISPLAY_FULL_IMPACT_HINTS: `Mostrar las indicaciones completas`,
  SETTINGS_PROBLEMS_MODE: `Modo predeterminado`,
  DEFAULT_PROBLEM_MODE: `Modo de notificación de problemas predeterminado`,
  INFINITE_PB_BUG: `En los últimos segundos se han creado gran número de problemas.<br>¿Desea seguir notificando problemas?`,
  INFINITE_PB_BUG_RESUME: `Se ha interrumpido la creación de nuevos problemas.<br>¿Desea crear nuevos problemas?`,
  SIMPLIFIED_MODE: `Modo simplificado`,
  ADVANCED_MODE: `Modo avanzado`,
  SETTING_SAVED: `Ajuste guardado`,
  THEME_LETTER: `Letra`,
  INDIC_UNIT: `Unidad`,
  INDIC_LIB_NAME: `(Biblioteca: {name})`,
  MAXIMUM: `Máximo`,
  MAXIMUM_SHORT: `Máx.`,
  MAXIMUM_SHORT_N: `Máx: {n}`,
  MINIMUM: `Mínimo`,
  MINIMUM_SHORT: `Mín.`,
  ADD_INDICATOR: `Añadir un indicador`,
  ADD_THEME: `Añadir un tema`,
  ADD_INDICATOR_FROM_LIBRARY: `Añadir desde la biblioteca`,
  IMPORT_PUBLIC_INDICATOR: `Importar un indicador público`,
  PUBLIC_INDIC_LETTER: `P`,
  INDIC_PUBLIC_FROM_OTHER_TEAM: `Este indicador es de otro equipo. Solo puede visualizar sus valores.`,
  DEFINE_MIN_MAX: `Definir un valor máximo o mínimo`,
  DEFINE_VISUAL_TYPE: `Tipo de gráfico`,
  CHART_TYPE: `Tipo de gráfico`,
  CHART_LINE: `Curva`,
  CHART_BAR: `Histograma`,
  LINE: `Curva`,
  BARS: `Barras`,
  PARETO: `Pareto`,
  SPECIFIC_SETTINGS: `Ajustes especiales`,
  SETTINGS_STATIC_VALUES: `Valores estáticos`,
  SETTINGS_INCREMENTAL_VALUES: `Valores incrementales`,
  SETTINGS_INCREMENT_NON_WD: `Incrementar durante los días no laborables`,
  SETTINGS_PUBLIC: `Público`,
  SETTINGS_PUBLIC_INDIC: `Indicador público`,
  SETTINGS_CALCULATED_INDIC: `Indicador calculado`,
  BETA_CALCULATED_INDIC: `Ya puede añadir indicadores calculados a partir de otros indicadores en su panel.<br>No dude en hacer sugerencias de mejora con el botón de la parte inferior derecha de la página.`,
  SETTINGS_INDICATOR_CALC_EXPR: `Calculo`,
  SETTINGS_INDICATOR_CALC_SMALL_HINT: `Haga clic en los botones que hay bajo el campo para rellenarlo y generar su cálculo.`,
  SETTINGS_INDICATOR_CALC_HINT: `@:message.SETTINGS_INDICATOR_CALC_SMALL_HINT <br>La opción "@:message.MANUAL_INPUT" permite dejar un campo vacío que rellenar cada día, mientras que la opción "@:message.INDICATOR_OF_MY_TEAM" añade automáticamente el valor del indicador que elija en el cálculo.<br>\
Ejemplo: Para calcular una tasa entre dos indicadores "Defectos" y "Piezas", haga clic en 1, 0, 0, ×, luego en "@:message.INDICATOR_OF_MY_TEAM", elija "Defectos", luego ÷ y añada el indicador "Piezas"`,
  SETTINGS_INDICATOR_CALC_EXPR_INVALID: `Cálculo no válido`,
  SETTINGS_CALC_WRONG_PERIOD_UNIT: `Los indicadores utilizados para el cálculo deben tener el mismo periodo para un determinado punto del gráfico.`,
  SETTINGS_CALC_INDIC_USED_PERIOD_UNIT: `Este indicador se utiliza en el cálculo de "{name}".<br>@:(message.SETTINGS_CALC_WRONG_PERIOD_UNIT).`,
  SETTINGS_INDIC_CALC_NOT_STATIC: `Los indicadores estáticos e incrementales no pueden ser objeto de un cálculo.`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC: `Promediar después del cálculo`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC_HINT: `Los valores se dividirán por el número de días laborables.`,
  INDIC_SPEC_SETTINGS_HELP: `Al elegir "valores estáticos", cada vez que introduzca un valor de indicador este seguirá siendo el mismo cada día hasta que defina un nuevo valor.<br/><br/>\
  La opción "Valores incrementales" funciona de la misma forma, pero los valores aumentan en la cantidad que haya definido junto a la casilla que marcar.<br/>De forma predeterminada, los valores aumentarán únicamente en los días laborables, pero también puede elegir incrementarlos en los días no laborables.<br/><br/>\
  Es posible añadir indicadores públicos a las tablas de otros equipos. Así, al marcar esta casilla, estará permitiendo a cualquier equipo de la empresa ver los valores de este indicador.\
  {gwHint}\
  Los valores de un indicador calculado se determinan a partir de una expresión matemática que puede escribir tras marcar la casilla.`,
  INDIC_INPUT_INTERVAL_SETTINGS: `Frecuencia de introducción de los valores`,
  INDIC_INPUT_SETTINGS_HELP: `Puede editar la frecuencia de introducción de este indicador.<br>Por ejemplo, al elegir un periodo de una semana, ya no podrá tener distintos valores del indicador cada día.<br>Además, los valores del indicador solo resultarán visibles cuando seleccione un modo de visualización semanal.`,
  INDIC_DISPLAY_WRONG_PERIOD: `Los valores de este indicador son {what}. Debe cambiar la visualización en curso.`,
  CHANGE_DISPLAY_INDIC_PERIOD: `Mostrar puntos {what}`,
  WEEKLY: `Semanal | Semanales`,
  MONTHLY: `Mensual | Mensuales`,
  MONTHLY_FEM: `Mensual | Mensuales`,
  OVER_LONGER_PERIOD: `En un periodo más largo`,
  CUMULATE: `Totalizar los valores`,
  CALC_AVERAGE: `Calcular la media`,
  INDICATORS_SAVED: `Indicadores guardados`,
  CONFIRM_DELETE_INDICATOR: `¿Desea realmente eliminar el indicador {0}?`,
  CONFIRM_DELETE_THEME: `¿Desea realmente eliminar el tema {0}? Al hacerlo, se eliminarán también todos los indicadores relacionados con este tema.`,
  NO_INDICATOR: `Ningún indicador`,
  INDIC_SETTINGS_OBJ_HINT: `(Objetivo en un periodo de {period})`,
  INDIC_SETTINGS_CHARTS_DISPLAY: `Visualización de los gráficos`,
  INDIC_SETTINGS_DISPLAY_VALUES: `Mostrar el valor de los puntos`,
  INDIC_SETTINGS_DISPLAY_VALUES_HINT: `Mostrar el valor textual de cada punto del gráfico junto a este.`,
  INDIC_SETTINGS_DISPLAY_LABELS: `Mostrar la fecha de los puntos en abcisa`,
  INDIC_SETTINGS_DISPLAY_LABELS_HINT: `Muestre la fecha de cada punto del gráfico si los puntos no totalizan el valor de varias fechas.`,
  INDIC_SETTINGS_NO_LABELS: `No mostrar`,
  INDIC_SETTINGS_DISPLAY_LABEL_DATE: `Mostrar la fecha`,
  INDIC_SETTINGS_DISPLAY_LABEL_CODE: `Mostrar un código (L M M J V)`,
  INDIC_SETTINGS_DISPLAY_LABELS_RADIO_HINT: `Al elegir mostrar un código, el gráfico mostrará L, M, M, J, V para los días de la semana, S1, S2, S3, para las semanas y Ene., Feb., Mar. para los meses.`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT: `Mostrar el impacto de los problemas en los gráficos`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT_HINT: `Muestre el impacto de los problemas notificados y resueltos en los gráficos de indicadores para identificar la consecuencia real de estos problemas en los rendimientos del equipo. Los gráficos mostrarán un punto rojo para los problemas notificados y uno verde para los problemas resueltos. El tamaño del punto dependerá del impacto de los problemas en esa fecha. Pase el ratón o el dedo sobre el punto para obtener más detalles.`,
  INDIC_SETTINGS_THEME_IS_GW: `Este tema de indicadores sólo contiene indicadores de inspección sobre el terreno`,
  INDIC_SETTINGS_IS_GW: `Este indicador es un indicador de inspección sobre el terreno`,
  INDIC_SETTINGS_GW_INDICATOR: `Indicadores de inspección sobre el terreno`,
  INDIC_SETTINGS_REGULAR_INDICATOR: `Indicador regular`,
  INDIC_SETTINGS_REGULAR: `Regular`,
  INDIC_SETTINGS_GW_HINT: `Al marcar "@:message.INDIC_SETTINGS_GW_INDICATOR", le dice a Shizen que este indicador no debe aparecer de forma predeterminada en la lista de KPI. Además, podrá utilizar este indicador durante sus inspecciónes sobre el terreno para introducir un valor numérico en lugar de una opción OK/NOK.`,
  INDIC_SETTINGS_GW_NEW_THEME_HINT: `Seleccione el nuevo tema para este indicador.`,
  INDIC_SETTINGS_REGULAR_THEMES: `Temas de los indicadores regular`,
  INDIC_SETTINGS_GW_THEMES: `Temas de los indicadores de inspección sobre el terreno`,
  INDIC_SETTINGS_GW_USAGE_NOT: `Este indicador no se utiliza en las plantillas de inspecciones sobre el terreno`,
  INDIC_SETTINGS_GW_USAGE: `Este indicador se utiliza {nTimes}.`,
  INDIC_SETTINGS_DELETE_THEME: `Eliminar el tema`,
  INDIC_SETTINGS_DELETE_INDIC: `Eliminar el indicador`,
  INDIC_SETTINGS_DELETE_ORPHAN_ITEMS: `{deleteWhat} y los elementos pertinentes de las listas de verificación`,
  INDIC_SETTINGS_DISPLAY_CALC_COMMENTS: `Mostrar los comentarios de los indicadores de cálculo`,
  INDIC_SETTINGS_ADAPTATIVE_RANGE: `Muestra el eje Y desde su valor más bajo hasta el más alto`,
  MGT_COMPACT_DISPLAY_GW_INDICATORS: `Visualizar los indicadores de inspección sobre el terreno en la vista compacta`,
  GW_INDICATORS_MOVED_TO_SETTINGS: `Ahora puede configurar sus indicadores a partir de los ajustes.`,
  IW_TITLE: `Mensajes de advertencia`,
  IW_NO_MSG_SET: `No se ha configurado ningún mensaje.`,
  IW_SET_A_MSG: `Configurar un mensaje`,
  IW_CUSTOM_MESSAGE: `Elija un mensaje personalizado para este indicador`,
  IW_MSG_PH: `Mensaje...`,
  IW_ALLOWED_OVERRUN: `Tolerancia de rebasamiento del objetivo`,
  IW_N_DAYS: `Duración del mensaje (en días)`,
  IW_CONFIRM_DELETE: `¿Desea realmente eliminar este mensaje?`,
  IW_YOUVE_SETUP: `Ha configurado un mensaje de advertencia para este indicador:<br/><br/>{msg}`,
  IA_HINTS: `Consejos del asistente`,
  HIDE_HINTS: `Ocultar los consejos del asistente`,
  INDIC_INPUT_DEFAULT_DATE: `Fecha de introducción de indicador`,
  INDIC_INPUT_DEFAULT_HINT: `Se trata de la fecha predeterminada, que debe seleccionarse al hacer clic en el botón "Introducción" de la página de indicadores detallados. Puede introducir a continuación el número de días entre la fecha del día y la fecha seleccionada de forma predeterminada.`,
  NB_OF_DAYS: `Número de días`,
  SIMPLIFIED: `Simplificada`,
  ADVANCED: `Avanzada`,
  PICTURES: `Imágenes`,
  TAKE_PICTURE: `Hacer una foto`,
  DONE: `Terminado`,
  BROWSE_GALLERY: `Examinar la galería`,
  PICK_PICTURE: `Elegir una imagen`,
  PICK_PICTURE_CAMERA_GALLERY: `Al hacer clic en este botón, el dispositivo le pedirá que elija entre la cámara y la galería.`,
  VISUAL: `Visual`,
  OPTIONAL: `Opcional`,
  DESCRIPTION: `Descripción`,
  DESCRIPTION_PH: `Descripción...`,
  DESCRIPTION_PLACEHOLDER: `Describa la acción`,
  DESCRIBE_PROBLEM: `Describa el problema`,
  DEFINE_IMPACT: `Determine su impacto`,
  LOCATE_PROBLEM: `Localice el problema`,
  LOCATION: `Lugar`,
  LOCATION_AND_ACTIONS: `Lugar y acciones`,
  CREATED_ON: `Creado el`,
  CREATED_BY: `Creado por`,
  WHO: `Quién`,
  WHAT: `Qué`,
  WHERE: `Dónde`,
  WHEN: `Cuándo`,
  WHY: `Por qué`,
  HOW: `Cómo`,
  HOW_MUCH: `Cuánto`,
  TYPE: `Tipo`,
  TYPES: `Tipos`,
  KEYWORDS: `Palabras clave`,
  IMPACT: `Impacto`,
  DEADLINE: `Plazo`,
  STATE: `Estado`,
  LAST_MODIFIED_DATE: `Fecha de última modificación`,
  ANALYSIS_STATE_DATE: `Fecha de inicio del análisis`,
  PICTURES_TITLE: `¿Tiene imágenes del problema?`,
  WHO_TITLE: `¿A quién afecta?`,
  WHAT_TITLE: `¿Qué ha ocurrido?`,
  WHERE_TITLE: `¿Dónde se ha producido el problema?`,
  WHEN_TITLE: `¿Cuándo se ha producido?`,
  WHY_TITLE: `¿Por qué es un problema?`,
  HOW_TITLE: `¿Cómo se ha producido?`,
  HOW_MUCH_TITLE: `¿Es posible medirlo, cuantificarlo?`,
  TYPE_TITLE: `¿De qué tipo de problema se trata?`,
  LOCATION_TITLE: `¿A qué lugares afecta este problema?`,
  INDICATORS_TITLE: `¿El problema está relacionado con un indicador?`,
  KEYWORDS_TITLE: `Elija palabras clave para identificar este problema`,
  IMPACT_TITLE: `Determine su impacto`,
  DEADLINE_TITLE: `¿Cuándo debe resolverse?`,
  SECURING_ACTIONS_TITLE: `¿Debe asegurarse el problema rápidamente?`,
  NEXT: `Siguiente`,
  NEX: `Sig`,
  PREV: `Ant`,
  PROBLEM_SAVED: `Problema guardado`,
  LEADER: `Responsable`,
  CATEGORIES: `Categorías`,
  UNIT: `Unidad`,
  ORIGINAL_DEADLINE: `Plazo inicial`,
  ORIGINAL_DEADLINE_SHORT: `Inicial`,
  ACTION_WAS_POSTPONED_N: `La acción nunca se ha notificado | Acción notificada {n} veces | Acción notificada {n} veces`,
  N_POSTPONEMENTS: `Ningún aplazimiento | Uno aplazimiento | {n} aplazimientos`,
  REASON: `Motivo`,
  REASON_PH: `@:message.REASON…`,
  STATE_POSTPONEMENT_REASON: `Introduzca un nuevo motivo de aplazamiento<br>o elija uno de la lista.`,
  POSTPONEMENT_REASON_NO_PREV: `No se ha encontrado ningún motivo.`,
  POSTPONEMENT_REASON: `Aplazimiento del {date}`,
  POSTPONEMENTS_HISTORY: `Historial de los aplazimientos`,
  NO_POSTPONEMENT_REASON: `No se ha especificado el motivo del aplazamiento.`,
  POSTPONEMENTS_NUMBER: `Número de aplazimientos`,
  POSTPONEMENTS_REASON: `Motivos de los aplazimientos`,
  PICK_A_PB: `Elija un problema`,
  AC_NOT_LINKED_PB: `Esta acción no está vinculada a un problema`,
  AC_NOT_LINKED_CAUSE: `Esta acción no está vinculada a una causa`,
  SECURING_ACTION: `Acción de emergencia`,
  SECURING_ACTIONS: `Acciones de emergencia`,
  DISPLAY_ONGOING_SECURING_ACTIONS: `Mostrar las acciones de emergencia en curso`,
  QUICK_ACTIONS: `Acciones rápidas`,
  LANDSCAPE_DISPLAY: `Mostrar planes de acción horizontalmente`,
  SECU_STATE_PENDING: `Acciones de emergencia en espera`,
  SECU_STATE_ONGOING: `Acciones de emergencia en curso`,
  SECU_STATE_COMPLETED: `Acciones de emergencia terminadas`,
  SAVE_BACK: `Guardar y volver a la página anterior`,
  SAVE_SHEET: `Guardar e ir a la ficha de problema`,
  SAVE: `Guardar`,
  SAVED: `Guardado`,
  SETTINGS_SAVED: `Ajustes guardados`,
  CONNECTION_ERROR: `Se ha producido un error. Vuelva a intentarlo más tarde.`,
  INDICATOR_MISSING: `Este indicador no existe o se ha eliminado. Puede modificar o eliminar esta etapa desde los ajustes de reuniones.`,
  WRONG_CREDENTIALS: `Compruebe el ID y la contraseña.`,
  LOGIN_SSO_NOT_ENABLED: `No se ha configurado el inicio de sesión por SSO en esta cuenta.`,
  LOGIN_LAST_ATTEMPT_TOO_CLOSE: `Se requiere un retraso de 2 segundos después de una conexión fallida. Por favor, inténtalo de nuevo.`,
  LOGIN_LOCK_ON_NEXT_FAIL: `Atención: Si vuelve a introducir una contraseña incorrecta, la cuenta puede bloquearse y no podrá iniciar la sesión.`,
  LOGIN_LOCKED_AFTER_FAILED_LOGIN: `Esta cuenta ha sido bloqueada tras varios intentos fallidos de inicio de sesión.`,
  LEAVING_CHANGES_BEHIND: `Hay cambios no guardados en esta página.`,
  EXIT_WITHOUT_SAVING: `Salir sin guardar`,
  SAVE_AND_EXIT: `Guardar y salir`,
  EXIT: `Salir`,
  LEAVE_WARNING: `Va a salir de esta página. Al hacerlo, se eliminarán todos los datos no guardados.`,
  CONTINUE: `Continuar`,
  ENTRY_DATE: `Fecha de introducción`,
  IN_PROGRESS: `En curso`,
  ENDED: `Terminado`,
  REMOVE: `Eliminar`,
  ARCHIVE: `Archivar`,
  PROBLEM_DELETED: `Problema eliminado`,
  PROBLEM_ARCHIVED: `Problema archivado`,
  PROBLEM_RESTORED: `Problema restablecido`,
  EXPORT_TO_EXCEL: `Exportar a formato Excel`,
  PB_EXPORT_ALL: `Exportar la lista de los problemas en formato Excel.`,
  ACTION_EXPORT_ALL: `Exportar la lista de acciones en formato Excel.`,
  ARCHIVED_THIS_WEEK: `¿Archivado esta semana?`,
  ARCHIVE_DATE: `Fecha de archivo`,
  WORK_START_DATE: `Fecha de inclusión en un plan de acción`,
  FIRST_ACTION_WORK_DATE: `Fecha de inicio de la primera acción`,
  ACT_DATE: `Fecha de transición al estado "Act"`,
  ACTIONS_PROBLEM_WHAT: `"Que" del problema`,
  ACTION_STATE_PENDING: `En espera`,
  ACTION_STATE_ONGOING: `En curso`,
  ACTION_STATE_COMPLETED: `Terminada`,
  PB_STATES: [
    `En espera de análisis`,
    `Análisis en curso`,
    `Acciones en curso`,
    `Acciones completadas`,
  ],
  DISPLAY_NUMBER_OF_ACTIONS_PENDING: `Mostrar el número de acciones pendientes en el menú de navegación.`,
  ACTIONS_COMPLETION_DATE: `Fecha de finalización de las acciones`,
  COMPLETED_ACTIONS: `Acciones terminadas`,
  ONGOING_ACTIONS: `Acciones en curso`,
  PENDING_ACTIONS: `Acciones en espera`,
  PENDING_PROBLEMS_: `No hay problemas en espera|Hay un problema en espera|Hay {n} problemas en espera`,
  COMPLETED_ACTIONS_: `No hay acciones terminadas|Hay una acción terminada|Hay {n} acciones terminadas`,
  CAUSE_NOT_VERIFIED: `Causa no verificada`,
  CAUSE_VERIFIED: `Causa verificada`,
  CAUSE_VERIFIED_REAL: `Causa real`,
  CAUSE_VERIFIED_NOT_REAL: `Causa falsa`,
  ADD_A_CAUSE: `Añadir una causa`,
  CAUSE_SUGGESTION: `Causa sugerida`,
  ADD_AN_ACTION: `Añadir una acción`,
  ACTION_SUGGESTION: `Sugerencias de acción`,
  ADD_SECURING_ACTION: `Añadir una acción de emergencia`,
  NEW_ACTION: `Nueva acción`,
  ADD_A_COMMENT: `Añadir un comentario`,
  CONFIRM_DELETE_COMMENT: `¿Seguro que desea eliminar esta comentario? (Esta operación es irreversible)`,
  COMMENT_SAVED: `Comentario guardado`,
  COMMENT_OF: `Comentarios de`,
  HOW_ADD_PICTURE: `¿Cómo desea añadir una imagen?`,
  NO_LEADER: `Ningún responsable`,
  AFFECT_TEAM_NO_LEADER: `Equipo {team} (Ningún responsable)`,
  GAIN: `Beneficio`,
  GAIN_UNIT_DEFAULT: `€`,
  DEFINE_GAIN: `Definir un beneficio`,
  COMMENTS: `Comentarios`,
  INDICATORS_AND_COMMENTS: `Indicadores y comentarios`,
  CLICK_TO_TYPE: `Haga clic aquí para escribir...`,
  CLICK_TO_CHANGE: `Haga clic aquí para modificar...`,
  COMMENT_PLACEHOLDER: `Añadir comentarios a la acción`,
  ACTION_LEADER_HISTORY: `Historial del responsable de la acción`,
  ACTION_CREATED_BY: `Acción creada por {name}`,
  ACTION_ASSIGNED_TEAMS: `El equipo "{fromTeamName}" ha enviado esta acción a "{toTeamName}"`,
  ACTION_RETURNED_TEAMS: `El equipo "{toTeamName}" ha reenviado esta acción a "{fromTeamName}"`,
  ACTION_LEADER_CHANGED: `El equipo "{teamName}" ha asignado esta acción a {toUser} ({toTeamName})`,
  RETURN_ACTION: `Reenviar la acción`,
  ACTION_RETURNED: `Acción reenviada`,
  ACTION_PENDING: `En espera`,
  EDIT: `Editar`,
  EDIT_PB: `Modificar el problema`,
  EDIT_PICTURES: `Modificar las imágenes`,
  PICTURES_UPDATED: `Imágenes actualizadas`,
  CAUSE_SELECT: `Seleccionar la causa`,
  CAUSE_UNSELECT: `Deseleccionar la causa`,
  CAUSE_DELETE: `Eliminar`,
  CAUSE_DELETE_CONFIRM: `¿Desea realmente eliminar esta causa? <br/>Al hacerlo, se eliminarán también las acciones e imágenes asociadas`,
  LATEST_PROBLEMS: `Últimos problemas notificados`,
  OTHER_PROBLEMS: `Otros problemas`,
  SORT_BY_IMPACT: `Por impacto`,
  SORT_BY_PROBLEM: `Por problema`,
  SORT_BY_ENTRY_DATE: `Por fecha de introducción`,
  SORT_BY_ADD_IN_ACTION_PLAN_DATE: `Por fecha de adición`,
  SORT_BY_DEADLINE: `Por plazo`,
  SORT_BY_SHEET_LAST_MODIFIED: `Por última actualización de la ficha`,
  SORT_BY_TITLE: `Por título (A-Z)`,
  SORT_BY_ARCHIVE_DATE: `Por fecha de archivo`,
  ALL: `Todo`,
  ALLS: `Todos`,
  UNASSIGNED: `No asignados`,
  UNASSIGNED_FEM: `No asignadas`,
  UNSPECIFIED: `No especificado`,
  ACTION_PLAN: `Plan de acción`,
  NEW_ACTION_PLAN: `Nuevo plan de acción`,
  ADD_ACTION_PLAN: `Añadir un plan de acción`,
  ACTION_PLAN_MAX_ACTIONS: `Número máximo de acciones`,
  ACTION_PLAN_DURATION: `Duración predeterminada de una acción`,
  DURATION: `Duración`,
  DURATION_BEFORE: `antes`,
  TWENTY_FOUR_HOURS: `24h`,
  HOURS: `Hora | Hora | Horas`,
  MINUTES: `Minuto | Minuto | Minutos`,
  SECONDS: `Segundo | Segundo | Segundos`,
  DAYS: `Día | Día | Días`,
  WEEKS: `Semana | Semana | Semanas`,
  MONTHS: `Mes`,
  N_TIMES: `0 vez | 1 vez | {nb} veces`,
  N_SECONDS: `0 segundo | 1 segundo | {nb} segundos`,
  N_HOURS: `0 hora | 1 hora | {nb} horas`,
  N_DAYS: `0 día | 1 día | {nb} días`,
  N_WEEKS: `0 semana | 1 semana | {nb} semanas`,
  N_MONTHS: `0 mes | 1 mes | {nb} meses`,
  EDIT_INDIC_VALUES: `Modificar los valores de los indicadores`,
  STOP_EDIT_INDIC_VALUES: `Fin de la modificación`,
  HIDE_SOME_INDICATORS: `Ocultar determinados indicadores`,
  N_HIDDEN_INDICATORS: `Ninguno | 1 indicador oculto | {nb} indicadores ocultos`,
  HIDE_INDICATORS_HINT: `Puede elegir ocultar uno o varios indicadores. En particular, esto puede serle útil cuando solo desee mostrar indicadores a corto o medio plazo.`,
  GROUPED_SELECTION: `Selección grupada`,
  SUPPORT_CHECKBOX: `Plan de apoyo (Mover acciones de este plan para asignarlas a otro equipo)`,
  ACTION_PLANS_SAVED: `Planes de acción guardados`,
  SAVE_ACTION_PLANS: `Guardar los planes de acción`,
  DELETE_ACTION_PLAN_CONFIRM: `¿Desea realmente eliminar este plan de acción? <br/>Esta operación es irreversible.<br/><br/>Las acciones que tenga asignadas volverán a ponerse en espera.`,
  DELETE_ACTION_PLAN: `Eliminar el plan de acción`,
  ACTION_PLAN_DELETED: `Plan de acción eliminado`,
  CANT_EDIT_SUPPORT_WITH_ACTIONS: `No se puede modificar un plan de acción de apoyo cuando contiene acciones de otro equipo.`,
  CANT_EDIT_PLAN_TYPE: `No se puede cambiar el tipo de un plan cuando contiene acciones.`,
  PLAN_DROP_HELP: `Arrastre aquí una acción para añadirla al plan`,
  ASSIGN_TO_PLAN_CONFIRM: `¿Desea asignar la acción "{actionName}" al plan "{planName}"?`,
  ASSIGN_ACTION: `Asignar la acción`,
  ASSIGN_TO_PLAN_IS_QUICK: `Esta acción es una acción rápida. Por tanto, no es posible añadirla a un plan específico.<br>En cambio, puede definirla como acción "en curso". Aparecerá en la columna "@:message.QUICK_ACTIONS" o "@:message.SECURING_ACTIONS" de la página Acciones.`,
  SET_ACTION_ONGOING: `Poner esta acción "en curso"`,
  ACTION_MAYBE_IN_OTHER_PLAN: `Se ha producido un error. Puede que la acción ya esté asignada a otro plan.`,
  REFRESHING_AVAILABLE_TEAMS: `Actualización de los equipos`,
  CHOOSE_SUPP_TEAM: `Elija el equipo de apoyo`,
  ACTION_ASSIGNED: `Acción asignada`,
  PLAN_FULL: `Este plan de acción parece lleno. Puede asignar esta acción a otro plan o eliminar acciones del plan.`,
  ONLY_PLAN_OWNER_ASSIGN: `Solo el equipo propietario del plan puede asignarle acciones`,
  CANT_ASSIGN_SELF: `Esta acción ya está asignada a su equipo.`,
  CONFIRM_ASSIGN_SAME_SUPPORT: `Puede intentar enviar esta acción al equipo que se lo haya asignado.<br/>Si desea devolver la acción, puede hacerlo haciendo clic en el botón "Reenviar" en la página de esa acción.<br/><br/>¿Desea realmente asignarla a este equipo?`,
  PROBLEM_SHEET: `Ficha de problema`,
  ACTION_SHEET: `Ficha de acción`,
  SUPPORT_LETTER: `S`,
  ACTION_FROM_OTHER_TEAM: `Esta acción le ha sido asignada por otro equipo.`,
  PROBLEM_FROM_GW: `Este problema se ha notificado durante una inspección sobre el terreno`,
  CANT_DELETE_BUT_RETURN: `No puede eliminarla, pero sí reenviarla.`,
  TEAM_ACTIONS: `Acciones del equipo`,
  ACTIONS_RECEIVED: `Acciones recibidas`,
  REMOVE_FROM_PLAN: `Quitar esta acción del plan de acción (En espera)`,
  REMOVE_FROM_PLAN_CONFIRM: `¿Desea volver a poner esta acción en espera?`,
  REMOVE_ACTION: `Quitar la acción`,
  ACTION_REMOVED: `Acción quitada`,
  ACTION_COMPLETED: `Acción terminada`,
  ACTION_COMPLETED_CONFIRM: `¿Esta acción está terminada?`,
  COMPLETE_ACTION: `Cerrar y archivar`,
  RESTORE_ACTION: `Revisar la acción`,
  ALL_A_ACTION_COMPLETED: `¿Archivar todas las acciones completadas`,
  ALL_A_ACTION_COMPLETED_CONFIRM: `¿@:message.ALL_A_ACTION_COMPLETED?`,
  CONFIRM_DELETE_ACTION: `¿Seguro que desea eliminar esta acción?<br/>Esta operación es irreversible.`,
  DELETE_ACTION: `Eliminar esta acción`,
  ACTION_DELETABLE_ASSIGNED: `Solo el equipo asignado puede eliminar esta acción.`,
  ACTION_DELETED: `Acción eliminada`,
  ACTION_RESPONSIBILITY_OTHER_TEAM: `Esta acción está bajo la responsabilidad de otro equipo y no tiene acceso a ella.`,
  CONFIRM_DELETE_PB: `¿Seguro que desea eliminar este problema?<br/>Esta operación es irreversible.`,
  CONFIRM_ARCHIVE_PB: `¿Seguro que desea archivar este problema?<br/>Puede restablecerlo desde la página de archivos.`,
  DEFAULT_PERIOD: `Periodo predeterminado`,
  ONE_DAY: `1 día`,
  SEVEN_DAYS: `7 días`,
  FOUR_WEEKS: `4 sem.`,
  TWELVE_MONTHS: `12 meses`,
  SEVEN_DAYS_SHORT: `7 d.`,
  FOUR_WEEKS_SHORT: `4 s.`,
  TWELVE_MONTHS_SHORT: `12 m.`,
  PERIOD: `Periodo`,
  LOADING: `Carga`,
  LOADING_DOTS: `Carga...`,
  BACK: `Volver`,
  INPUT: `Entrada`,
  DISPLAY: `Mostrar`,
  DONT_DISPLAY: `No mostrar`,
  DISPLAY_NOUN: `Visualización`,
  DISPLAY_VALUES: `Mostrar los valores`,
  CUSTOM_DISPLAY: `Visualización personalizada`,
  ENTER_A_NUMBER: `Vuelva a introducir un valor`,
  INDIC_VALUE_HINT_SAVED: `Se ha guardado este valor`,
  INDIC_VALUE_HINT_NOT_SAVED: `No se ha guardado este valor`,
  INDICATOR_VALUE_SAVED: `Valor del indicador guardado`,
  INDIC_VALUE_BEFORE_COMMENT: `Si desea añadir un comentario, debe introducir un valor.`,
  CONFIRM_DELETE_INDIC_VAL: `¿Desea realmente eliminar este valor?<br/>Al hacerlo, también se eliminará el comentario asociado.`,
  INDICATOR_VALUE_DELETED: `Valor eliminado`,
  N_VALUES: `0 valor|1 valor|{nb} valores`,
  INDIC_COMMENT_NEED_VALUE: `Para añadir un comentario, primero debe introducir un valor.`,
  CANT_EDIT_PUBLIC_INDIC: `No puede modificar este indicador porque pertenece a otro equipo.`,
  INDICATOR_OBJECTIVE_SAVED: `Objetivo guardado`,
  NO_ACCESS: `Su equipo no tiene acceso a este contenido`,
  SETTINGS_DISPLAY_CURRENT_INFOS: `Mostrar los datos recientes`,
  CRITICAL_PROBLEMS: `Problemas críticos`,
  LOWEST_POSSIBLE_IMPACT: `Impacto mínimo de los problemas mostrados en el panel`,
  ELAPSED_DAYS_SINCE_REPORT: `Número de días desde su notificación`,
  DEFAULT_DB_INDIC_VIEW: `Vista predeterminada de los indicadores`,
  N_DB_ACTIONS_LINES: `Número de líneas que mostrar para una acción`,
  DISPLAY_GAIN: `Mostrar el campo "Beneficio"`,
  MEETINGS_ADD_INFO: `Información adicional durante las reuniones`,
  HIDE_INFO_GW: `Ocultar la información sobre las próximas inspecciones sobre el terreno`,
  HIDE_INFO_SUGGESTIONS: `Ocultar las sugerencias en la página de información`,
  MEETINGS_PLANNINGS: `Planificaciones de las reuniones`,
  PLANNINGS: `Planificaciónes`,
  PLANNING: `Planificación`,
  ADD_PLANNING: `Añadir una planificación`,
  DELETE_PLANNING_CONFIRM: `¿Desea eliminar esta planificación?`,
  PLANNINGS_SAVED: `Reuniones guardadas`,
  PLANNING_DELETED: `Reunión eliminada`,
  NEW_MEETING: `Nueva reunión`,
  MEETING_NAME: `Nombre de la reunión`,
  MEETING_ROLES: `Roles`,
  MEETING_NO_ROLES: `Aún no se han asignado los roles`,
  REPEATABILITY: `Repeticiones`,
  EVERY_DAY: `Cada día`,
  EVERY_WEEK: `Cada semana`,
  EVERY_MONTH: `Cada mes`,
  APPLY_TIME_PLANNING: `Aplicar a los otros días`,
  ONCE: `Una vez`,
  DAY: `Día`,
  DAY_OF_MONTH: `Día del mes`,
  TIME: `Horario`,
  MONDAY: `Lunes`,
  TUESDAY: `Martes`,
  WEDNESDAY: `Miércoles`,
  THURSDAY: `Jueves`,
  FRIDAY: `Viernes`,
  SATURDAY: `Sábado`,
  SUNDAY: `Domingo`,
  DATE_SWITCHER_DISABLED: `Estas flechas permiten cambiar el periodo de visualización de los indicadores. A la hora de modificar los valores, utilice las flechas que aparecen junto a los valores de los indicadores.`,
  STEP: `Etapa`,
  STEPS: `Etapas`,
  ADD_STEP: `Añadir una etapa`,
  STEP_NB: `Etapa n.° {stepNumber}`,
  STEP_MIN_DURATION: `Mínima : {stepDuration}`,
  SEE_PAGE: `Ver la página`,
  MGT_INDICATORS: `Indicadores de gestión`,
  STATS_FROM_MGT: `Estadísticas de gestión`,
  SAFETY_SECTION: `Sesión de seguridad`,
  LINKS_TO_PAGE: `Envío a la página`,
  CHOOSE_SETTINGS: `Elegir los ajustes`,
  DETAILED_INDICATOR: `Indicador detallado`,
  INDICATOR_INPUT: `Entrada de indicador`,
  MEETING_PAGES: `Páginas de reunión`,
  MAIN_PAGES: `Páginas principales`,
  MGT_PAGES: `Páginas de gestión`,
  MEETING_END: `Fin de la reunión`,
  START: `Iniciar`,
  STARTING: `Inicio...`,
  END: `Fin`,
  PARTICIPANTS: `Participantes`,
  ADD_PARTICIPANTS: `Añadir participantes`,
  START_MEETING: `Iniciar la reunión`,
  MEETING_END_CONFIRM: `¿Desea terminar la reunión?`,
  MEETING_ENDED: `Reunión terminada`,
  MEETING_LEAVE_CONFIRM: `¿Desea salir de la reunión?`,
  MEETING_LEAVE: `Salir de la reunión`,
  MEETING_STARTED_JOIN: `Se ha iniciado una reunión. ¿Desea participar?`,
  JOIN_MEETING: `Participar`,
  DONT_JOIN_MEETING: `No participar`,
  MEETING_OVER: `La reunión ha terminado`,
  MEETING_REMOTELY_CLOSED: `La reunión ha terminado`,
  ERROR_SAME_MEETING: `Ya está participando en esta reunión`,
  NOTICE_LEAVE_MEETING: `Al efectuar esta acción, saldrá de la reunión en curso.`,
  MT_CURRENT_PAGE: `Ir a la página en curso`,
  MEMBERS: `Miembros`,
  FIRST_NAME: `Nombre`,
  LAST_NAME: `Apellidos`,
  ID: `ID`,
  USERNAME: `Nombre de usuario`,
  LOCATION_CLICK_HINT: `Haga clic para elegir un lugar`,
  WORKING_HOURS: `Horarios de trabajo`,
  DAY_START: `Inicio de la jornada`,
  DAY_END: `Fin de la jornada`,
  SEEK_ROOT_CAUSES: `Buscar las causas raíz`,
  FIVE_WHYS: `5 por qué`,
  ISHIKAWA: `Ishikawa`,
  SHOW_ALL_ACTIONS: `Ver todas las acciones del problema`,
  CAUSE_SAVED: `Causa guardada`,
  CONFIRM_DELETE_FW_CAUSE: `¿Seguro que desea eliminar esta causa?<br/>Al hacerlo, se eliminarán también todas las causas que dependan de ella.<br/><br/>Esta operación es irreversible.`,
  CAUSE_DELETED: `Causa eliminada`,
  DISPLAY_IN_SHEET: `Mostrar en la ficha de problema`,
  DISPLAY_IN_SHEET_SHORT: `Mostrar en ficha`,
  HIDE: `Ocultar`,
  SELECT_ROOT_CAUSES: `Seleccione las causas que se mostrarán en la ficha de problema`,
  CONFIRM_DELETE_STICKER: `¿Eliminar la etiqueta? Esta operación es irreversible.`,
  SUGGESTIONS: `Sugerencias`,
  SUGGESTION: `Sugerencia`,
  ADD_A_SUGGESTION: `Nueva sugerencia`,
  MAIN_MENU: `General`,
  TEAMS_MANAGEMENT: `Gestión`,
  CURRENT_INFOS: `Información en curso`,
  NEW_INFO: `Nueva información`,
  MANAGER_TEAMS_TITLE: `Equipos de {manager}`,
  NO_TEAMS: `Ningún equipo`,
  SELECT_CHILDREN_TEAMS: `Seleccionar los equipos supervisados`,
  SELECT_CHILDREN_TEAMS_SHORT: `Sel. supervisados`,
  SELECT_BY_HIERARCHY: `Sel. por niv. jerárquico`,
  SELECT_ALL_LVL: `Nivel {lvl}`,
  NO_ACCESS_TO_TEAM: `No tiene acceso a este equipo`,
  SELECTED_TEAMS: `Equipos seleccionados`,
  INFO_RELEASE_DATE: `Fecha de difusión`,
  CREATION_DATE: `Fecha de creación`,
  INFO_REMOVAL_DATE: `Fecha de finalización`,
  RELEASE_INFO: `Difundir`,
  DEFAULT_DISPLAY: `Visualización predeterminada`,
  INFO_SAVED: `Información guardada`,
  NO_TEAMS_SELECTED: `Ningún equipo seleccionado`,
  N_TEAMS_SELECTED: `Ningún equipo seleccionado|1 equipo seleccionado|{nb} equipos seleccionados`,
  N_TEAMS_SELECTED_NAMES: `@:message.N_TEAMS_SELECTED ({teamNames})`,
  INFO_MESSAGE: `Mensaje de información`,
  INFO_DELETE_CONFIRM: `¿Eliminar esta información? (Esta operación es irreversible)`,
  INFO_DELETE: `Eliminar`,
  INFO_DELETED: `Información eliminada`,
  INFO_FW: `Transferir`,
  INFO_FW_PICK_TEAM: `Elija al menos un equipo al que desee enviar esta información.`,
  INFO_UPCOMING_GW: `Una inspección sobre el terreno "{name}" tendrá lugar en las siguientes fechas: {dates}`,
  ADDITIONAL_INFO: `Información adicional`,
  INFO_RELATED_GW: `Inspección sobre el terreno relacionada`,
  INFO_DISABLED_HINT_GW: `Esta información no puede modificarse, ya es un resumen de una inspeccion sobre el terreno.`,
  INFO_DISABLED_HINT_OTHER_TEAM: `Esta información no puede ser modificada ya que fue creada por otro equipo.`,
  RECIPIENTS: `Destinatarios`,
  NB_REPORTED_PB: `{nb} notificado | {nb} notificado | {nb} notificados`,
  NB_COMPLETED_PB: `{nb} terminado | {nb} terminado | {nb} terminados`,
  ONGOING_PROBLEMS: `Problemas en curso`,
  MONTH: `Mes`,
  WEEK: `Semana`,
  TODAY: `Hoy`,
  TODAY_SHORT: `Hoy`,
  YESTERDAY: `Ayer`,
  TEAMS_ACTIONS: `Acciones de los equipos`,
  NB_LATE_ACTIONS: `de las cuales {nb} con retraso`,
  QUICK_ACTION: `Acción rápida`,
  PDCA: `PDCA`,
  PDCA_BEFORE_P: `Esp.`,
  PDCA_PLAN: `Plan`,
  PDCA_DO: `Do`,
  PDCA_CHECK: `Check`,
  PDCA_ACT: `Act`,
  PDCA_ACT_ARCHIVED: `Act (archivada)`,
  PDCA_P: `P`,
  PDCA_D: `P`,
  PDCA_C: `C`,
  PDCA_A: `A`,
  PDCA_MUST_BE_IN_PLAN: `Ponga la acción en un plan de acción para cambiar la etapa`,
  LATE_ACTIONS: `Acciones con retraso`,
  LATEST_NEWS: `Información reciente`,
  FROM_TEAM: `Del equipo "{team}"`,
  FROM_YOUR_TEAM: `De su equipo`,
  UPCOMING_INFOS: `Próximo/a`,
  INFOS_N_MEETING_SUGG: `Ninguna sugerencia en esta reunión|Una sugerencia para esta reunión|{n} sugerencias para esta reunión`,
  TEAM_INFOS_SHORT: `Recibidas`,
  SENT_INFOS_SHORT: `Enviadas`,
  OUR_TEAM: `Nuestro equipo`,
  TEAM_INFOS: `Nuestros informatiónes por este equipo`,
  SENT_INFOS: `La información enviada por este equipo`,
  INFO_DISPLAY_FULL_INFO: `Mostrar todo el contenido de los elementos`,
  VISUAL_MODE: `Vista`,
  TEMPLATE: `Plantilla`,
  COMPACT: `Compacta`,
  CUMUL: `Total.`,
  OVER_PERIOD_FROM_TO: `Durante el periodo de {start} a {end}`,
  AVERAGE_GAP_TO_THE_GOAL: `Media de las diferencias respecto a los objetivos por equipo`,
  TEAM_AVERAGE_GAP: `El equipo "{team}" tiene una diferencia media de {gap}{percStr} respecto al objetivo en este periodo.`,
  TEAM_VALUES_OK_OBJECIVE: `En este periodo, el equipo "{team}" tiene valores conformes con sus objetivos`,
  MGT_SELECTED_INDICATORS: `Indicadores seleccionados ({n})`,
  N_EMPTY_VALUES: `Ningún valor no indicado|1 valor no indicado|{nb} valores no indicados`,
  N_VALUES_OUTSIDE: `Ningún valor con diferencia respecto al objetivo|1 valor con diferencia respecto al objetivo|{nb} valores con diferencia respecto al objetivo`,
  N_VALUES_COMPLY: `Ningún valor corresponde al objetivo|1 valor corresponde al objetivo|{nb} valores corresponden al objetivo`,
  PICTURES_FROM_PROBLEMS: `Imágenes de los problemas`,
  CURRENT_PICTURES: `Imágenes actuales`,
  FROM_DEVICE: `Desde el dispositivo`,
  PICTURES_FROM_SLEAN: `Imágenes de Shizen`,
  CLICK_TO_EDIT: `Haga clic aquí para editar`,
  CONFIRM_REMOVE_STEP: `¿Eliminar esta etapa?`,
  CUSTOM_PAGE: `Página personalizable`,
  CUSTOM_TEXT_PH: `Texto personalizado...`,
  REPORTED_PB_NUMBER: `Número de problemas notificados`,
  ONGOING_PB_NUMBER: `Número de problemas en curso`,
  COMPLETED_PB_NUMBER: `Número de problemas resueltos`,
  PROBLEM_DISTRIBUTION_TYPE: `Distribución de problemas por tipo`,
  REPORTED_ACTIONS_NUMBER: `Número de acciones creadas`,
  ONGOING_ACTIONS_NUMBER: `Número de acciones en curso`,
  COMPLETED_ACTIONS_NUMBER: `Número de acciones terminadas`,
  ACTIONS_POSTPONED: `Número de aplazamientos de acciones`,
  REPORTED_GW_PB_NUMBER: `Problemas procedentes de las inspecciones sobre el terreno`,
  REPORTED_GW_ACTIONS_NUMBER: `Acciones procedentes de las inspecciones sobre el terreno`,
  PROBLEM_DISTRIBUTION_INDICS: `Distribución de problemas por indicador`,
  PROBLEM_RECURRENCE_BREAKDOWN: `Distribución de la recurrencia de los problemas`,
  MEETING_RATING_DISTRIBUTION: `Distribución de las reuniones por calificación`,
  PICTURE_SAVED: `Imagen guardada`,
  MEETING_STARTED_RESUME: `Se ha iniciado una reunión "{name}" hace unos minutos en este dispositivo.<br/>¿Reanudar la reunión?`,
  RESUME: `Reanudar`,
  DISCARD_MEETING: `Salir`,
  IA_HELP: `¿Necesita ayuda?`,
  IA_ANALYSIS: `Análisis`,
  IA_ANALYSIS_TEXT: `¿Quiere obtener un análisis?`,
  ANALYSING: `Análisis en curso...`,
  VALUE: `Valor`,
  OBJECTIVE: `Objetivo`,
  OBJECTIVE_SHORT: `Obj.`,
  MAX_OBJECTIVE: `máx: {objective}`,
  MIN_OBJECTIVE: `mín: {objective}`,
  OUTSIDE_OBJECTIVE: `{out} / {in} valores incumplen el objetivo.`,
  OUTSIDE_OBJECTIVE_10_DAYS: `{out} valores incumplen el objetivo en estos últimos 10 días.`,
  WHAT_DO_BACK_OBJECTIVE: `¿Qué acciones se pueden adoptar rápidamente para volver al objetivo?`,
  NB_DAYS_IN_A_ROW_OUTSIDE: `{nb} días seguidos con un valor que incumple el objetivo, del {fromDate} al {toDate}.`,
  WHY_OUTSIDE_OBJECTIVE: `¿Por qué el indicador incumple el objetivo?`,
  IS_OBJECTIVE_RIGHT: `¿Es correcto el objetivo?`,
  IS_OBJECTIVE_AMBITIOUS: `¿Es demasiado ambicioso?`,
  NEED_LINKED_PROBLEM: `¿Hay algún problema crítico relacionado con este indicador?`,
  N_INDIC_ISSUES_FOUND: `No he encontrado ningún problema particular en estos indicadores.|He encontrado un indicador que precisa su atención.| He encontrado {nb} indicadores que precisan su atención.`,
  INDIC_ISSUES_CHECK_OUT: `Tal vez debería ver de qué se trata.`,
  INDIC_LONGEST_STRAIGHT_OUTSIDE: `Hay al menos un indicador con {nb} valores seguidos que incumplen el objetivo.`,
  NO_PROBLEMS: `Ningún problema`,
  NO_COMPLETED_PROBLEMS: `Ningún problema terminado`,
  NO_COMPLETED_ACTIONS: `Ninguna acción terminada`,
  NO_CRITICAL_PROBLEM: `Ningún problema crítico en estos últimos días.`,
  IS_IMPACT_CORRECTLY_SET: `¿Se ha indicado correctamente el impacto de los problemas?`,
  N_CRITICAL_PROBLEM: `Ningún problema crítico en estos últimos días.|Se ha encontrado un problema crítico en estos últimos días|Se han encontrado {nb} problemas críticos en estos últimos días`,
  N_CRITICAL_PENDING_PROBLEM: `.|&nbsp;de los cuales uno en espera.|&nbsp;de los cuales {n} en espera.`,
  CRITICAL_PROBLEM_MUST_BE_RESOLVED: `Un problema crítico debe abordarse en un plazo de 48 horas.`,
  N_ACTIONS: `Ninguna acción|Una acción|{nb} acciones`,
  N_PROBLEMS: `Ningún problema|Un problema|{nb} problemas`,
  N_PROBLEM_MONTHS: `&nbsp;en estos últimos 30 días, {nbPrev} en los 30 días anteriores.`,
  N_PROBLEM_INCREASE: `Aumento del {nb} %.`,
  N_PROBLEM_DECREASE: `Disminución del {nb} %.`,
  N_PROBLEMS_REPORTED: `0 problemas notificados | Un problema notificado | {nb} problemas notificados`,
  N_PROBLEMS_RESOLVED: `0 problemas resueltos | Un problema resuelto | {nb} problemas resueltos`,
  N_RES_REP_PROBLEMS_IMPACT_SUM: `{nProblems} (Suma de los impactos: {impact})`,
  NO_PROBLEMS_SINCE: `La última notificación de problemas fue hace {nDays} días.`,
  DAILY_MGT_MEANS_DAILY_PROBLEMS: `En la gestión diaria del rendimiento, por lo general se notifica un problema al día como mínimo.`,
  TEACH_PROBLEM_REPORTING: `La notificación de problemas permite mejorar las condiciones de trabajo del equipo.`,
  N_UNASSIGNED_ACTIONS: `Hay {nb} acciones no asignadas. Una acción incluida en un plan debe tener un coordinador.`,
  USER_MORE_THAN_60PERC_ACTIONS: `El usuario {user} tiene más del 60 % de las acciones.`,
  ACTIONS_DISTRIBUTION_STLT: `Distribución de las acciones: {st}% A corto plazo / {lt} % A largo plazo`,
  EVERYONE_SHOULD_PARTICIPATE: `Si es posible, distribuya las acciones entre los miembros del equipo.`,
  DAILY_MGT_ST_LT: `En la gestión diaria, la mayoría de las acciones deben preverse a corto y medio plazo.`,
  N_LATE_ACTIONS: `Ninguna acción con retraso.|Una acción con retraso.|Hay {nb} acciones con retraso.`,
  IA_HAVE_YOU_TALKED_ABOUT_IT: `¿Ha hablado de ello recientemente?`,
  REPORT_PROBLEM: `Notificar un problema`,
  PROBLEM_TRUST_INDEX: `Índice de confianza del problema: {index}%`,
  PROBLEM_WELL_DESCRIBED: `El problema se ha descrito correctamente. ¡Enhorabuena!`,
  IA_HOW_PROBLEM_MUST_BE_DESCRIBED: `Los problemas deben estar bien descritos para que sea posible darles una resolución óptima. En concreto, es fundamental contar con una representación visual y rellenar el "Que" y el "Por qué".`,
  CAUSES_TRUST_INDEX: `Índice de confianza de las causas: {index}%`,
  CAUSES_ARE_TRUE_CAUSES: `¡Las causas parecen ser causas reales!`,
  IA_WHAT_IS_TRUE_CAUSE: `Una causa tiene un índice de confianza más elevado si se describe con ayuda de una imagen.`,
  ACTIONS_TRUST_INDEX: `Índice de confianza de las acciones: {index}%`,
  ACTIONS_WELL_LINKED: `Ningún problema, sus acciones están asociadas correctamente a las causas del problema.`,
  IA_ACTIONS_SHOULD_BE_LINKED_TO_CAUSES: `Si ha determinado las causas raíz del problema, asocie las acciones a estas causas para asegurarse de su pertinencia.`,
  IMPROVE_PROBLEM_DECRIPTION: `Describir mejor el problema`,
  PROBLEM_NEEDS_PICTURE: `La mejor forma de describir un problema es mediante la fotografía.<br/>Usted ve o ha visto el problema, pero no la persona que va a leer su descripción. Sus compañeros podrían comprender el problema de forma distinta a como usted lo vio, con lo que intentarían resolver un problema que no es tal.`,
  IDENTIFIER: `ID`,
  IA_TEACH_WHAT: `Planteamos esta pregunta para obtener una mejor descripción del problema.<br/><br/>Ejemplos:<br/><em>¿De qué se trata?<br/>¿Cuál es el estado de la situación?<br/>¿Cuáles son las consecuencias?<br/>¿Cuáles son los riesgos?</em>`,
  IA_TEACH_WHO: `Esta pregunta permite a cada persona entender a quién afecta el problema.<br/><br/>Ejemplos:<br/><em>¿A quién afecta?<br/>¿Quién tiene el problema?<br/>¿Quién se ve afectado por las consecuencias del problema?<br/>¿Quién puede verse afectado por su resolución?</em>`,
  IA_TEACH_WHERE: `Esta pregunta está relacionada con la descripción de los lugares. El problema puede efectivamente producirse en un lugar por un motivo y en otro lugar por otro distinto.<br/><br/>Ejemplos:<br/><em>¿Dónde se ha producido el problema?<br/>¿A qué lugares afecta?<br/>¿A qué área de producción, a qué máquina?</em>`,
  IA_TEACH_WHEN: `Planteamos esta pregunta para definir adecuadamente los tiempos. Esto le ayudará a relacionar problemas que surjan en las mismas circunstancias temporales.<br/><br/>Ejemplos:<br/><em>¿Desde cuándo presenta este problema?<br/>¿Cuándo aparece?<br/>¿Cuándo se descubrió el problema?<br/>¿Cuál es su frecuencia?<br/>¿Cuándo se produce el riesgo?</em>`,
  IA_TEACH_HOW: `Para una mejor comprensión de la forma o el método para encontrar y resolver este problema.<br/><br/>Ejemplos:<br/><em>¿Cómo se produce el problema?<br/>¿En que condiciones o circunstancias?<br/>¿Cómo proceder?<br/>¿Existen métodos que emplear?<br/>¿De qué manera emprender su resolución, con qué procedimientos?</em>`,
  IA_TEACH_HOWMUCH: `Esto permite cuantificar todo lo relacionado con el problema.<br/><br/>Ejemplos:<br/><em>¿Qué cantidad de agua inunda el área de producción?<br/>¿Cuántos errores ha habido antes de detectar el problema?</em>`,
  IA_TEACH_WHY: `Esa es la primera etapa de resolución del problema. Puede empezar preguntándose "¿Por qué?" con cada una de las preguntas anteriores.<br/>Una vez que la descripción del problema sea precisa y esté completa, podrá proceder a efectuar un análisis de los "5 por qué", lo que le permitirá detectar las causas reales del problema.`,
  IA_TEACH_PROBLEM_TYPES: `Atribuir un tipo a un problema permite a su equipo clasificarlo en una categoría. A continuación, podrá ordenar los problemas más fácilmente.`,
  INCREASE_CAUSES_TRUST: `Aumentar la confianza de las causas`,
  IA_CAUSE_NEEDS_DESC: `Atribuir un nombre o una descripción a una causa es fundamental para poder confirmarla. Utilizar palabras clave permite lograr una comprensión común del motivo por el cual el problema es una consecuencia de la causa.`,
  IA_CAUSE_NEEDS_PICTURE: `Al igual que sucede con la descripción del problema, la fotografía permite a cualquier persona comprender rápidamente el significado exacto de la descripción.<br/>Una imagen es la prueba de que la causa es real y debe resolverse.`,
  ADD_DESCRIPTION: `Añadir una descripción`,
  ADD_PICTURE: `Añadir una imagen`,
  PICTURE: `Fotografía`,
  IA_CAUSE_NEEDS_ANY: `La causa está vacía. Una causa vacía no permite resolver un problema. Si ha encontrado una causa, debería al menos atribuirle un nombre o una descripción.`,
  MEETING_RATING: `Autoevaluación`,
  RATE_MEETING: `Atribuya una calificación a la reunión`,
  NO_RATING: `Sin calificación`,
  UNACCEPTABLE: `Inaceptable`,
  ACCEPTABLE: `Aceptable`,
  MEETING_ACTIONS: `Acciones`,
  MEETING_ACTION_PH: `Acción para las próximas reuniones`,
  REDIRECTING_TO_DASHBOARD: `Redirección a la página de inicio...`,
  RATING_UPDATED: `Calificación actualizada`,
  LOGOUT: `Cierre de sesión`,
  LOGGING_OUT: `Cierre de sesión en curso...`,
  CAMERA_UNAVAILABLE: `Este dispositivo no está disponible`,
  NOT_AUTHORIZED_CAMERA: `El uso de la cámara no está autorizado. Vuelva a actualizar la página o modifique los ajustes de autorizaciones.`,
  WAKING_NEO_UP: `Espere... vamos a despertar a Neo`,
  ROLES_ASSIGNEMENT: `Asignación de los roles`,
  ROLE_LEADER: `Coordinador`,
  ROLE_TIME_KEEPER: `Controlador del tiempo`,
  ROLE_CARE_TAKER: `Crítico`,
  ROLE_DECISION_LEADER: `Impulsor de decisiones`,
  ROLE_FOCUS_KEEPER: `Líder concienciador`,
  ROLE_LEADER_DEF: `Indica el ritmo, facilita la organización del trabajo.`,
  ROLE_TIME_KEEPER_DEF: `Ayuda al coordinador a gestionar el tiempo en función de las etapas de la reunión.`,
  ROLE_CARE_TAKER_DEF: `Observa las interacciones humanas, comprueba nadie quede al margen. <br/>Puede intervenir para que todos puedan expresarse.`,
  ROLE_DECISION_LEADER_DEF: `Impulsa y anota las decisiones. <br/>También toma notas durante la reunión sobre puntos esenciales (decisiones, plazos, responsabilidades...).`,
  ROLE_FOCUS_KEEPER_DEF: `Recuerda la finalidad de la reunión y de cada una de sus etapas. <br/>Ayuda a centrarse en la intención correcta.`,
  ROLE_ASSIGNED: `Rol atribuido`,
  ROLES_RANDOM: `Roles aleatorios`,
  ROLES_REROLL: `Los roles se restablecerán antes de reasignarse`,
  DETAILS: `Detalles`,
  USERS: `Usuarios`,
  TEAMS: `Equipos`,
  COMPANY_DETAILS: `Detalles de la empresa`,
  COMPANY_NAME: `Nombre de la empresa`,
  COMPANY_ID: `ID de la empresa`,
  CONTACT_EMAIL: `Email de la empresa`,
  EMAIL: `Email`,
  ACCESS: `Acceso`,
  USERS_NB: `Número de usuarios`,
  TEAMS_NB: `Número de equipos`,
  CHANGE_CONFIG_PASSWORD: `Modificar la contraseña de administrador`,
  COMPANY_ID_EXAMPLE: `11000`,
  PWD_BETWEEN_8_25: `La extensión de la contraseña debe ser de entre 8 y 25 caracteres`,
  PWD_DONT_MATCH: `Las contraseñas no coinciden`,
  PWD_EDITED: `Contraseña actualizada`,
  PWD_ERROR_CHECK: `Se ha producido un error, compruebe los campos`,
  OLD_PASSWORD: `Contraseña anterior`,
  NEW_PASSWORD: `Nueva contraseña`,
  NEW_PASSWORD_CONFIRM: `Confirmación`,
  LOGO_URL: `URL del logotipo`,
  LOGO_URL_PLACEHOLDER: `Introduzca aquí la URL del logotipo...`,
  USE_WHITE_BG: `Fondo blanco`,
  LOGO_UPDATED: `Logotipo actualizado`,
  CFG_CHARTS_COLOR: `Color de los gráficos`,
  CFG_COLOR_BLUE: `Azul`,
  CFG_COLOR_GREEN: `Verde`,
  CFG_CHARTS_FILLING: `Relleno de los gráficos`,
  CFG_CHARTS_FILL_GOOD: `Rellenar la zona bajo los valores conformes al objetivo`,
  CFG_CHARTS_FILL_BAD: `Rellenar la zona bajo los valores que incumplen el objetivo`,
  CFG_CHARTS_COLOR_OPACITY: `Opacidad del relleno`,
  CFG_CHARTS_COLOR_OPACITY_HINT: `Grado de opacidad del color de relleno. Cuanto más próximo esté el valor de 0, más transparente será el relleno. Cuanto más próximo esté el valor de 100, más opaco será el relleno.`,
  SORT_AZ: `de la A a la Z`,
  SORT_BY_LEVEL: `por nivel jerárquico`,
  SORT_BY_TEAMS: `por equipo`,
  SORT_BY_TEAMS_AZ: `por equipo (de la A a la Z)`,
  SORT_BY_CREATION_DATE: `fecha de creación`,
  HIERARCHY_LEVEL: `Nivel jerárquico`,
  FILTER_BY_TEAM: `Filtrar por equipo de referencia`,
  TEAM_UPDATED: `Equipo actualizado`,
  TEAMS_UPDATED: `Equipos actualizados`,
  USER_UPDATED: `Usuario actualizado`,
  USERS_UPDATED: `Usuarios actualizados`,
  IMPORT_XLSX: `Importar un archivo de Excel`,
  XLSX_FILE_ERROR: `Se ha producido un error con el archivo. No dude en pedir consejo a Neo.`,
  XLSX_FILE_SEEMS_EMPTY: `El archivo de Excel parece estar vacío. No dude en pedir consejo a Neo.`,
  XLSX_KEEP_TEMP_FORMAT: `Conserve el formato de la plantilla tal cual. No dude en pedir consejo a Neo.`,
  DOWNLOAD_XLSX_TEMPLATE: `(Descargar la plantilla)`,
  TEAM: `Equipo`,
  USER: `Usuario`,
  NEW_TEAM: `Nuevo equipo`,
  NEW_USER: `Nuevo usuario`,
  NAME: `Apellidos`,
  YOUR_NAME: `Su nombre`,
  ALREADY_CREATED_TEAMS: `Equipos ya presentes`,
  ADDING_USERS: `Inclusión de usuarios...`,
  USERS_ADDED: `Usuarios creados`,
  DELETE_SELECTION: `Eliminar`,
  ASSIGN_SELECTION: `Asignar a un equipo`,
  UNSELECT_TEAM: `Deseleccionar el equipo`,
  SELECT_ALL: `Seleccionar todo`,
  UNSELECT_ALL: `Deseleccionar todo`,
  CONFIRM_DELETE_USERS: `¿Desea realmente eliminar estos usuarios? <br/>Al hacerlo, también se eliminarán los datos asociados.`,
  CONFIRM_DELETE_TEAMS: `¿Desea realmente eliminar estos equipos? <br/>Al hacerlo, también se eliminarán los datos asociados.<br/><br/>Entre ellos se incluyen los problemas y sus resoluciones, las acciones, los indicadores y sus valores, así como los datos relativos a las reuniones.`,
  TEAMS_REMOVED: `Equipo/s eliminado/s`,
  USERS_REMOVED: `Usuario/s eliminado/s`,
  CONFIG_ALLOW_SENDING_INFO_ANY_TEAM: `Permitir a los equipos enviar información a cualquier otro equipo`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON: `Invitar a los usuarios a indicar un motivo para aplazar una acción`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON_HINT: `Al cambiar el plazo de una acción a una fecha posterior, Shizen invitará a los usuarios a introducir el motivo del aplazamiento que se mostrará en la ficha de la acción.`,
  CONFIG_INDICATORS: `Config. indicadores`,
  CONFIG_DELETE_INDICATORS: `Eliminar los indicadores`,
  CONFIG_INDICATOR_CHOICES: `¿Cómo desea configurar los indicadores?<br/><br/><em>Al utilizar una plantilla, podrá ver los valores totalizados de todos los equipos que comparten la misma plantilla.<br/>También puede copiar los ajustes de otro equipo. Sin embargo, ese equipo tendrá utilizar una plantilla para tener acceso a la consolidación de los dos equipos.</em><br/><br/>Si decide eliminar los indicadores de este equipo, no podrá recuperar ninguno de los valores que este haya introducido.<br/>Si estos indicadores proceden de una plantilla, los equipos que utilicen esa misma plantilla no se verán afectados.`,
  CONFIG_CURRENT_SCHEME: `El equipo {team} utiliza la plantilla "{schemeName}".`,
  CONFIG_CURRENT_NOSCHEME: `El equipo {team} no utiliza ninguna plantilla.`,
  CONFIG_CURRENT_SCHEME_PLUR: `Los equipos {teams} utilizan la plantilla "{schemeName}".`,
  CONFIG_CURRENT_NOSCHEME_PLUR: `Los equipos {teams} no utilizan ninguna plantilla.`,
  CONFIG_ENUM_SEP: `, `,
  CONFIG_ENUM_LAST_SEP: ` y `,
  CONFIG_DISPLAY_TEAMLESS_USERS: `Mostrar usuarios sin equipo de referencia`,
  CONFIG_DISPLAY_ADMINS_ONLY: `Sólo mostrar administradores`,
  CONFIG_CANT_DELETE_SELF: `No puedes borrarte a ti mismo.`,
  CONFIG_CANT_REMOVE_LAST_ADMIN: `No se puede eliminar al último administrador de la empresa.<br>Es necesario que haya al menos un administrador.`,
  CONFIG_CANT_DELETE_ADMIN_TEAM: `No se puede eliminar un equipo si se utiliza como equipo de referencia para un administrador.<br>Puedes eliminar el rol de administrador de este usuario o moverlo a otro equipo.`,
  CONFIG_CHOOSE_TEMPLATE: `Elegir una plantilla`,
  COPY_SETTINGS_FROM_OTHER_TEAM: `Copiar`,
  CONFIG_WORKING_DAYS: `Config. días laborables`,
  CONFIG_ACTION_PLANS: `Asignar planes de acción`,
  CONFIG_PLANS_CHOICES: `Cree nuevos planes de acción para estos equipos o copie los ajustes de otro equipo.`,
  CREATE_NEW_PLANS: `Nuevos planes de acción`,
  CONFIG_ASSIGN_CFG_PAGES: `Asignar páginas configurables`,
  CONFIG_ASSIGN_MEETINGS: `Asignar reuniones`,
  CONFIG_INDIC_SCHEMES: `Plantillas de indicadores`,
  CONFIG_NO_SCHEMES_FOUND: `Ninguna plantilla encontrada.`,
  CONFIG_TEAMS_DISPLAY_TEAMS: `Mostrar los equipos que utilizan esta plantilla`,
  CONFIG_TEAMS_USING_TEMPLATE: `Estos equipos utilizan este plantilla`,
  CONFIG_TEAMS_NOT_USING_TEMPLATE: `Estos equipos no utilizan esta plantilla`,
  CONFIG_TEAMS_NONE_USING_TEMPLATE: `Ningún equipo utiliza esta plantilla`,
  CONFIG_CREATE_TEMPLATE: `Nueva plantilla`,
  CONFIG_SCHEME_NAME: `Nombre de la plantilla`,
  CONFIG_SCHEME_NAME_PH: `Nombre de la plantilla...`,
  CONFIG_DELETE_SCHEME: `Si elimina esta plantilla, los equipos que la utilicen dejarán de poder utilizar sus indicadores.`,
  CONFIG_SCHEME_DELETED: `Plantilla eliminada.`,
  CONFIG_SCHEME_DEFAULT: `Vista predeterminada en la página de gestión`,
  CONFIG_SCHEME_DEFAULT_HINT: `Marque esta casilla para que esta plantilla aparezca seleccionada de forma predeterminada en la página de gestión de los indicadores.`,
  CONFIG_CONFIRM_NO_EMAIL: `Si utiliza una dirección de email no válida para este equipo, sus datos de inicio de sesión se enviarán a info@shizen.io.`,
  CONFIG_TEAM_EDITION: `Modificación de un equipo`,
  CONFIG_TEAM_NAME_HINT: `El nombre del equipo es el nombre utilizado por Shizen para identificarlo en las páginas del producto. Es preferible elegir un nombre diferente del de otros equipos para evitar confusiones.`,
  CONFIG_TEAM_EMAIL_HINT: `Esta dirección de email se utiliza principalmente para restablecer la contraseña. También se utiliza como dirección de email predeterminada para todos los usuarios que no han indicado su propia dirección.`,
  CONFIG_TEAM_HIERARCHY_LEVEL_HINT: `El nivel jerárquico es una forma de identificación visual de ayuda a los administradores.`,
  CONFIG_TEAM_ACCESSES_HINT: `Indique aquí la lista con todos los usuarios que deben tener acceso a los datos de este equipo.`,
  CONFIG_TEAM_REMOTE_IDP_ID: `Si en su proveedor de identidades ha incluido grupos correspondientes a los equipos de Shizen, indique aquí el ID del grupo que corresponde a este equipo.`,
  CONFIG_REMOTE_IDP_ID: `ID del grupo del IdP`,
  CONFIG_COMPANY_INTERNAL_ID: `Identificador interno de la empresa`,
  CONFIG_COMPANY_INTERNAL_ID_HINT: `Identificador utilizado internamente.`,
  CONFIG_USER_EDITION: `Modificación de un usuario`,
  CONFIG_USER_MUST_HAVE_TEAM: `Este usuario debe formar parte de un equipo`,
  CONFIG_USERNAME_ALREADY_EXISTS: `Este nombre de usuario ya está en uso`,
  CONFIG_EMAIL_ALREADY_IN_USE: `Esta dirección de email ya está en uso`,
  CONFIG_EMAIL_INVALID: `Esta dirección de email no parece ser válida`,
  CONFIG_USERNAME: `Nombre de usuario`,
  CONFIG_PREFERRED_TEAM: `Equipo de referencia`,
  CONFIG_SEND_USERS_NEW_CREDENTIALS: `Enviar nuevos ID`,
  CONFIG_SEND_CREDENTIALS_CONFIRM: `¿Desea restablecer la contraseña de estos usuarios y enviarles una nueva contraseña por email?<br>Si alguna dirección de email de estos usuarios no es válida, se utilizará la dirección de email del equipo en su lugar.`,
  CONFIG_RESET_AND_SEND_CREDENTIALS: `Restablecer y enviar`,
  CONFIG_UPDATE_SENDING_USER_EMAIL: `Actualización y envío de emails a los usuarios`,
  CONFIG_USER_NAMES_HINT: `El nombre y los apellidos del usuario se mostrarán en las listas de usuarios de los equipos y cada vez que el usuario sea responsable de una acción o de una resolución de problema, por ejemplo.`,
  CONFIG_USERNAME_HINT: `El nombre de usuario permite a este iniciar sesión en Shizen. También puede iniciar sesión utilizando el ID de su equipo.`,
  CONFIG_USER_EMAIL_HINT: `La dirección de email permite concretamente restablecer la contraseña del usuario cuando este la ha olvidado. También podrá configurar notificaciones por email en la plataforma.`,
  CONFIG_USER_TEAM_HINT: `El equipo de referencia es el equipo en el que el usuario iniciará sesión de forma predeterminada en Shizen. También indica el nivel jerárquico del usuario.`,
  CONFIG_USER_TEAMS_HINT: `Los equipos aquí seleccionados son todos los equipos de los cuales es miembro este usuario. Cuando ha iniciado sesión, el usuario puede pasar de una cuenta de equipo a otra cuando desee.`,
  CONFIG_THIS_USER_TEAM: `El equipo de este usuario`,
  CONFIG_USER_ACCESSES_HINT: `El usuario tendrá una posición de gestión con respecto a los equipos seleccionados. Cualquier usuario que haya iniciado sesión en "{teamName}" (equipo de referencia de este usuario) podrá disponer de una vista de gestión de estos equipos y enviarles información.`,
  CONFIG_HIERARCHY_TREE: `Organigrama de los equipos`,
  CONFIG_DISPLAY_HIERARCHY_TREE: `Mostrar el organigrama de los equipos`,
  CONFIG_HIERARCHY_TREE_HINT: `Este organigrama se ha creado a partir de las relaciones jerárquicas existentes entre los equipos.<br>\
Mientras un equipo no esté gestionado por otro, aparecerá en la base del organigrama.<br>\
Para intentar modificar el organigrama, realice cambios en los campos "@:message.SUPERVISOR_TEAMS" y "@:message.SUPERVISED_TEAMS" de los equipos. También puede reorganizar los equipos en el organigrama directamente arrastrándolos y soltándolos.`,
  CONFIG_GW_DISALLOW_COMPLETED_EDITING: `No permitir la edición de inspección sobre el terreno completados`,
  SUPERVISOR_TEAMS: `Equipos directores`,
  SUPERVISED_TEAMS: `Equipos supervisados`,
  SUPERVISOR_TEAMS_HINT: `Equipos responsables de la gestión. En el organigrama, aparecerá "{name}" justo debajo de los equipos que seleccione en este campo. Si este equipo debe estar en la base del organigrama, no seleccione ningún equipo.`,
  SUPERVISED_TEAMS_HINT: `Efecto contrario al del campo anterior. Los equipos aquí seleccionados son todos los equipos dirigidos por "{name}"`,
  SUPERVISOR_TEAM_ERROR: `El equipo "{name}" no puede ser un equipo director. Ya forma parte de los equipos supervisados, o está gestionado por uno de los equipos supervisados.`,
  SUPERVISED_TEAM_ERROR: `El equipo "{name}" no puede ser supervisado. Dirige a este equipo, o dirige uno de los equipos directores.`,
  SUPERVISOR_TEAM_SELF_ERROR: `Un equipo no puede supervisarse a sí mismo.`,
  CONFIG_USER_ROLES: `Derechos del usuario`,
  CONFIG_USER_ADMIN_ACCESS: `Permitir el acceso a la config`,
  CONFIG_USER_ADMIN_ACCESS_HINT: `Al marcar esta casilla, el usuario tendrá acceso a todas las páginas de la config (donde se encuentra actualmente). <strong>¡ Sólo permite el acceso a la configuración a los usuarios formados !</strong>`,
  CONFIG_USER_PROBLEMS_ACCESS: `Permitir crear y actualizar el problema`,
  CONFIG_USER_PROBLEMS_ACCESS_HINT: `Marcar esta casilla permite al usuario poder crear y actualizar problemas`,
  CONFIG_USER_SETTINGS_ACCESS: `Permitir el acceso a la configuración del equipo`,
  CONFIG_USER_SETTINGS_ACCESS_HINT: `Marcar esta casilla permite al usuario poder cambiar la configuración de su equipo.`,
  CONFIG_USER_SSO_ID: `ID de SSO`,
  CONFIG_USER_SSO_ID_HINT: `Este campo permite crear una correspondencia entre el proveedor de identidades (IdP) y los usuarios de Shizen. Para obtener más información, consulte @:message.DETAILS > @:(message.SETTINGS_SAML).`,
  CONFIG_SSO_ID_ALREADY_IN_USE: `Este ID de SSO ya está en uso`,
  CONFIG_ENABLE_ACCOUNT: `Activar las cuentas`,
  CONFIG_DISABLE_ACCOUNT: `Desactivar las cuentas`,
  CONFIG_DISABLE_ACCOUNT_CONFIRM: `La desactivación de estas cuentas cerrará las sesiones de los usuarios y les impedirá volver a iniciar sesión en Shizen.<br>Estos usuarios dejarán de aparecer en las listas de usuarios de las cuentas de los equipos.`,
  CONFIG_ENABLE_ACCOUNT_CONFIRM: `¿Desea activar estas cuentas para permitir que los usuarios vuelvan a iniciar sesión?`,
  CONFIG_ACCOUNTS_ENABLED: `Cuentas activadas`,
  CONFIG_ACCOUNTS_DISABLED: `Cuentas desactivadas`,
  CONFIG_STARTUP_TEMPLATE: `Utilizar una plantilla de inicio`,
  CONFIG_SAML_PASSWORD_PROTECTED: `Activar el método "PasswordProtectedTransport" en Authn Context`,
  CONFIG_ENABLE_SAML: `Activar la autenticación por SAML (Single Sign On)`,
  CONFIG_FORCE_SAML: `Forzar la autenticación por SAML`,
  CONFIG_FORCE_SSO_HINT: `Al marcar esta casilla, dejará de estar disponible la autenticación clásica en Shizen y se redirigirá automáticamente al usuario al inicio de sesión en el IdP.`,
  CONFIG_SAML_ENTITY_ID: `ID de entidad (Entity ID)`,
  CONFIG_SAML_SSO_URL: `URL de inicio de sesión (SSO URL)`,
  CONFIG_SAML_SLO_URL: `URL de cierre de sesión (SSO URL)`,
  CONFIG_SAML_CERT: `Certificado (base 64)`,
  CONFIG_IMPORT_SAML_XML_META: `Importar los metadatos en formato XML`,
  CONFIG_EXPORT_SAML_XML_META: `Exportar los metadatos en formato XML`,
  CONFIG_IMPORT_SAML_META_HINT: `Su IdP podría proporcionarle un archivo de metadatos descargable en formato XML, para no tener la necesidad de rellenar los campos siguientes.`,
  CONFIG_SAML_META_FILE_WRONG: `El archivo proporcionado no parece ser compatible con el protocolo SAML 2.0.`,
  CONFIG_COMPANY_SSO_IDP: `Detalles del proveedor de identidades de su empresa (Identity Provider)`,
  CONFIG_SHIZEN_SSO_SP: `Detalles de Shizen como Proveedor de Servicios (Service Provider)`,
  CONFIG_SAML_SP_ENTITY: `ID de la entidad del proveedor de servicios`,
  CONFIG_SAML_ACS_URL: `URL del servicio de consumidor de aserciones (ACS)`,
  CONFIG_SAML_SLS_URL: `URL del servicio de cierre de sesión (SLS)`,
  CONFIG_SSO_MATCH_IDP_SHIZEN: `Correspondencia entre el proveedor de identidades (IdP) y los usuarios de Shizen`,
  CONFIG_SSO_MATCH_IDP_SHIZEN_HINT: `Para autenticarse en Shizen, los usuarios deberán autenticarse primero en el proveedor de identidades (IdP). A continuación, el IdP redirigirá al usuario a Shizen y proporcionará ciertos datos que permitirán a Shizen autenticarlo. Para ello, debe elegir aquí la propiedad que se utilizará para esta autenticación.`,
  CONFIG_SAML_EXAMPLE_HINT: `Tras la autenticación en el IdP, Shizen buscará un usuario, donde {shizenProperty} corresponde al atributo "{idpProperty}" de los datos del IdP.`,
  CONFIG_SSO_MAPPER_IDP_PROP: `Propiedad del IdP`,
  CONFIG_SSO_MAPPER_SHIZEN_PROP: `Propiedad de un usuario de Shizen`,
  CONFIG_SAML_SP_PROPS: {
    email: `el email`,
    username: `el nombre de usuario`,
    ssoId: `el ID de SSO`,
  },
  CONTACT_SHIZEN_ADMIN: `Para obtener más información, póngase en contacto con el administrador de su cuenta de Shizen.`,
  LOGIN_SSO_IDP_FAILED_AUTHENTICATION: `La autenticación de su proveedor de identidades ha fallado.`,
  LOGIN_SSO_MAPPER_WRONG_IDP_PROP: `Los datos recibidos desde su proveedor de identidades no contienen ciertos datos requeridos.`,
  LOGIN_SSO_USER_NOT_FOUND: `La autenticación se ha efectuado, pero no se ha encontrado ningún usuario de Shizen que corresponda a esta cuenta.`,
  LOGIN_SSO_NEW_USER_PROPS_MISSING: `No existe su cuenta en Shizen. El proveedor de identidades no ha enviado todos los datos requeridos.`,
  LOGIN_SSO_NEW_USER_NO_TEAM_MATCH: `No existe su cuenta en Shizen y los grupos del proveedor de identidades no coinciden con ningún equipo de Shizen.`,
  LOGIN_SSO_NEW_USER_CREATION_ERROR: `Se ha producido un error al crear su cuenta`,
  LOGIN_SSO_SUCCESSFUL: `Acaba de iniciar sesión, se le ha autenticado como @:(fullNameFormat).`,
  BETA_SSO_LOGIN: `Ya puede iniciar sesión por SSO (Single Sign On). Puede probar esta función en cuanto la configure su administrador.`,
  CONFIG_TEST_SSO_LOGIN: `Probar la conexión`,
  CONFIG_SETTINGS_OIDC: `Ajustes de autenticación por OpenID Connect (SSO)`,
  CONFIG_ENABLE_OIDC: `Activar la autenticación por OIDC (Single Sign On)`,
  CONFIG_FORCE_OIDC: `Forzar la autenticación por OIDC`,
  CONFIG_OIDC_CLIENT_ID: `ID de cliente`,
  CONFIG_OIDC_SERVER_URL: `URL raíz del proveedor de identidades`,
  CONFIG_OIDC_SECRET: `Clave secreta del proveedor de identidades`,
  CONFIG_OIDC_ACS_URL: `URL de redirección`,
  CONFIG_OIDC_SLO_URL: `URL de cierre de sesión (opcional)`,
  CONFIG_CANT_SSO_BOTH_SAML_OIDC: `No puede utilizar SAML y OpenID Connect a la vez. Si desea autorizar el inicio de sesión mediante OpenID Connect, desactive la conexión por SAML, y viceversa.`,
  CONFIG_SSO_IDP_GROUPS: `Grupos`,
  CONFIG_SSO_AUTO_CREATE_USERS: `Crear los usuarios automáticamente`,
  CONFIG_SSO_AUTO_CREATE_USERS_HINT: `También tiene la posibilidad de activar la creación automática de usuarios haciendo corresponder los equipos de Shizen con los grupos creados en su IdP. Para ello, cree un grupo para cada equipo de Shizen y, a continuación, para cada uno de estos equipos, rellene el campo "@:message.CONFIG_REMOTE_IDP_ID" en los ajustes del equipo.<br>Por último, indique aquí el nombre de las propiedades enviadas por su proveedor de identidades para identificar a los usuarios y sus grupos en cada inicio de sesión.`,
  CONFIG_SSO_OIDC_ADD_CLAIM_HINT: `Probablemente debería añadir reivindicaciones (claims) desde su proveedor de identidades, como los grupos asociados a un usuario mediante el ID token.`,
  CONFIG_OIDC_SCOPES_HINT: `Indique los scopes (ámbitos) que necesite (separe cada valor con un espacio).<br>Por ejemplo, si requiere una creación de usuario automática, probablemente necesite un campo para acceder al nombre, a los apellidos y al grupo del usuario.`,
  CONFIG_OIDC_SCOPES: `Scopes`,
  CONFIG_OIDC_SCOPES_PH: `openid profile email`,
  CONFIG_PROBLEMS: `Configuración de los problemas`,
  CONFIG_STARTUP_TEMPLATES: `Plantillas de inicio`,
  CONFIG_SUT_NAME_PH: `Nombre de la plantilla`,
  CONFIG_SUT_N_SCHEMES: `Ninguna plantilla de indicadores|1 plantilla de indicadores|{n} plantillas de indicadores`,
  CONFIG_SUT_N_PAGES: `Ninguna página configurable|1 página configurable|{n} páginas configurables`,
  CONFIG_SUT_N_PLANNINGS: `Ninguna reunión|1 reunión|{n} reuniones`,
  CONFIG_SUT_NEW: `Nueva plantilla de inicio`,
  CONFIG_SUT_CONFIRM_DELETE: `¿Seguro que desea eliminar esta plantilla?`,
  CONFIG_SUT_APPLY_SELECTED: `Aplicar las plantillas`,
  CONFIG_ACTIONS_HINT: `Aquí se puede definir planes de acción modelos, para asignar a sus equipos.<br>Cree uno o más planes aquí, luego asígnelos a sus equipos desde la configuración del equipo o usando los modelos de inicio.`,
  CONFIG_ACTION_PLAN_TEMPLATES: `Planes accion modelos`,
  CONFIG_ACTION_PLAN_LIST_TEAMS: `Equipos que utilizan este plan`,
  LOCATIONS: `Lugares`,
  ADD_A_LOCATION: `Añadir un lugar`,
  DELETE_SUBZONES: `¿Desea también eliminar los lugares que contiene?`,
  SAVE_BEFORE_ASSIGN: `No se ha guardado esta acción. Guarde sus cambios para asignar la acción.`,
  PB_NOT_FOUND: `No se encuentra este problema. Puede que se haya eliminado.`,
  PB_GO_BACK: `Volver`,
  NO_CAUSE: `No hay ninguna causa asociada`,
  NO_CAUSE_SELECTED: `No hay ninguna seleccionada`,
  ACTION_UPDATED: `Acción actualizada`,
  FS_NOT_SUPPORTED: `La función de pantalla completa no está disponible en este navegador.`,
  NOTIFICATIONS: `Notificaciones`,
  NOTIFICATION: `Notificación`,
  NOTIFICATION_TYPE: `Tipo de notificación`,
  NOTIFICATION_EMAIL: `Correo electrónico`,
  NOTIFICATIONS_SEE: `Configuración de las notificaciones para`,
  NOTIFICATIONS_SETTINGS_INFO: `Aquí puede definir su configuración personal de notificaciones.<br>Puede activar/desactivar las notificaciones que le conciernen a usted o a su equipo, así como los correos electrónicos asociados a esa notificación.`,
  NOTIFICATION_COUNT: `Ninguna notificación nueva|Una notificación no leída|{count} notificaciones no leídas`,
  NOTIF_TYPE_UPCOMING_MEETING: `Próxima reunión`,
  NOTIF_TYPE_MEETING_STARTED: `Reunión iniciada`,
  NOTIF_TYPE_ACTION_ASSIGNED: `Nueva acción asignada al equipo`,
  NOTIF_TYPE_ACTION_COMPLETE: `Acción completada por otro equipo`,
  NOTIF_TYPE_PROBLEM_RECEIVED: `Problema recibido`,
  NOTIF_TYPE_GW_STARTED: `Inspección sobre el terreno iniciada`,
  NOTIF_TYPE_INFO_RELEASED: `Nueva información`,
  NOTIF_TYPE_PROBLEM_ACCESS_REVOKED: `Acceso al problema cancelado`,
  NOTIF_TYPE_ACTION_RETURNED: `Acción reenviada`,
  NOTIF_TYPE_USER_ACTION_ASSIGNED: `Acción asignada`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE: `Plazo de acción vencido`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING: `Acercamiento del plazo de una acción`,
  NOTIF_TYPE_PROBLEM_COMMENT: `Comentario sobre un problema`,
  NOTIF_TYPE_PROBLEM_UPDATE: `Problema actualizado`,
  NOTIF_TITLE_UPCOMING_MEETING: `@:message.NOTIF_TYPE_UPCOMING_MEETING : {name}`,
  NOTIF_TITLE_ONGOING_MEETING: `@:message.NOTIF_TYPE_MEETING_STARTED : {name}`,
  NOTIF_TITLE_NEW_SUPPORT_ACTION: `Nueva acción: {name}`,
  NOTIF_TITLE_SUPPORT_ACTION_DONE: `Acción terminada: {name}`,
  NOTIF_TITLE_PROBLEM_RECEIVED: `@:message.NOTIF_TYPE_PROBLEM_RECEIVED : {name}`,
  NOTIF_TITLE_GW_STARTED: `@:message.NOTIF_TYPE_GW_STARTED : {name}`,
  NOTIF_TITLE_INFO_RELEASED: `@:message.NOTIF_TYPE_INFO_RELEASED`,
  NOTIF_TITLE_PB_ACCESS_REVOKED: `@:message.NOTIF_TYPE_PROBLEM_ACCESS_REVOKED : {name}`,
  NOTIF_TITLE_ACTION_RETURNED: `@:message.NOTIF_TYPE_ACTION_RETURNED : {name}`,
  NOTIF_TITLE_USER_ACTION_ASSIGNED: `@:message.NOTIF_TYPE_USER_ACTION_ASSIGNED : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_OVERDUE: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_APPROACHING: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING : {name}`,
  NOTIF_TITLE_PROBLEM_COMMENT: `Nuevo comentario : {name}`,
  NOTIF_TITLE_PROBLEM_UPDATE: `@:message.NOTIF_TYPE_PROBLEM_UPDATE : {name}`,
  OTHER_CONNECTED_USERS: `Usuarios conectados`,
  PB_HELP_HINT: `Compartir`,
  PB_HELP_SHARE: `Puede compartir este problema con otros equipos`,
  PB_HELP_NO_TEAM_FOUND: `No se ha encontrado ningún equipo.`,
  PB_HELP_ADD_TEAMS: `Añadir equipos`,
  PB_HELP_TEAMS_NOTIFIED: `Se ha informado a los equipos`,
  PB_HELP_REVOKED: `Se ha eliminado el acceso`,
  PB_HELP_ACCESS_GRANTED: `Otro equipo le ha enviado este problema`,
  PB_NO_ACCESS: `Parece que no tiene acceso a este problema.`,
  PB_EDITION_ERROR: `No se ha podido editar el problema.<br/>Si este persiste, intente actualizar la página.`,
  PB_AUTO_REFRESH: `Act. auto.`,
  PB_REPORT_SAVE_BEFORE_LEAVE: `¿Desea guardar el problema antes de salir de la página?`,
  PB_BEEN_REPORTED_TODAY: `Este problema ha sido notificado en las últimas 24 horas`,
  YES_LEAVE_SAVE: `Sí <em class="ml10">(Guardar y salir)</em>`,
  NO_LEAVE_WITHOUT_SAVING: `No <em class="ml10">(Salir y eliminar)</em>`,
  CANCEL_NOT_LEAVING: `Cancelar <em class="ml10">(No salir)</em>`,
  PB_DELETING: `Eliminación del problema...`,
  ACTION_SAVE_BEFORE_LEAVE: `¿Desea guardar la acción antes de salir de la página?`,
  ACTION_DELETING: `Eliminación de la acción...`,
  INFO_SAVE_BEFORE_LEAVE: `¿Desea guardar la información antes de salir de la página?`,
  CAUSE_EDITION_ERROR: `No se ha podido editar la causa. Puede que otro usuario la haya eliminado.<br/>Si el problema persiste, intente actualizar la página.`,
  NEW_VERSION_RELOAD: `Existe una versión más reciente disponible. Para utilizarla, actualice la página.`,
  ACCOUNT_LOCKED: `Esta cuenta se ha bloqueado, por lo que no puede iniciar sesión en ella.`,
  REFRESH: `Actualizar`,
  LIST: `Lista`,
  START_NOW: `Iniciar`,
  CALENDAR: `Calendario`,
  MEETING: `Reunión`,
  MEETING_FL: `R`,
  GW: `Inspección sobre el terreno`,
  GW_FL: `TT`,
  GW_RESTRICTED_ACCESS: `Lo sentimos, no tiene acceso a esta página.`,
  GEMBA_WALKS: `Inspecciones sobre el terreno`,
  GW_MENU: `@:message.GEMBA_WALKS`,
  GW_COMPLETE: `Inspecciones sobre el terreno terminadas`,
  GW_CONFIRM_DELETE: `¿Seguro que desea eliminar esta inspección sobre el terreno?<br/>Esta operación es irreversible.`,
  GW_ITEM_DELETED: `Elemento eliminado`,
  GW_BY_MY_TEAM: `Por este equipo`,
  GW_FOR_MY_TEAM: `Para este equipo`,
  GW_TEMPLATES: `Plantillas de inspecciones sobre el terreno`,
  GW_NEW_TEMPLATE: `Nueva plantilla`,
  GW_CREATING_TEMPLATE: `Creación de una nueva plantilla`,
  GW_EDITING_TEMPLATE: `Modificación de una plantilla`,
  GW_TEMPLATE_CONFIRM_DELETE: `¿Seguro que desea eliminar esta plantilla?<br/>Esta operación es irreversible.`,
  GW_DUPLICATION_NAME: `Introduzca el nombre de la nueva plantilla.`,
  GW_TEMPLATE_DUPLICATED: `Plantilla duplicada`,
  GW_EDIT_START: `Modificar antes de iniciar`,
  GW_CHECKLISTS: `Listas de verificación`,
  GW_0_STEPS: `No se ha creado ninguna etapa`,
  GW_CL_DELETE: `Eliminar`,
  GW_CL_DELETED: `Lista eliminada`,
  GW_CL_DELETE_ORPHAN: `Eliminar y suprimir los indicadores no utilizados`,
  GW_CL_CONFIRM_DELETE: `¿Seguro que desea eliminar esta lista?<br/>Esta operación es irreversible.`,
  GW_CONFIRM_DELETE_ITEM: `¿Seguro que desea eliminar este elemento?<br/>Esta operación es irreversible.`,
  GW_CL_ITEMS: `Elementos`,
  GW_CL_ITEMS_COUNT: `Ningún elemento en esta lista| 1 elemento en esta lista| {count} elementos en esta lista`,
  GW_CL_ITEM_NB: `Elemento n.º{nb}`,
  GW_CL_ITEM_TYPE: `Tipo de elemento`,
  GW_CL_ITEM_TYPE_OKNOK: `Punto de verificación (OK / No OK)`,
  GW_CL_ITEM_TYPE_GW_INDICATOR: `Entrada de un indicador de inspección sobre el terreno`,
  GW_CL_ITEM_TYPE_DMP_INDICATOR: `Entrada de un indicador de un equipo`,
  GW_CL_ADD_ITEM: `Añadir un elemento`,
  GW_CL_UNTICK_OPTIONS: `¿Desea eliminar esta lista de control o modificarla?`,
  GW_CL_REMOVE: `Eliminar de la etapa`,
  GW_CL_EDIT: `Modificar`,
  GW_SAVED: `¡Guardado!`,
  GW_NAME: `Nombre`,
  GW_NAME_PLACEHOLDER: `Nombre de la inspección sobre el terreno`,
  GW_OBJECTIVE: `Objetivo`,
  GW_OBJECTIVE_PLACEHOLDER: `Describa el objetivo`,
  GW_SHOULD_SET_AUDITED_USER: `Seleccionar los usuarios que serán auditados durante la inspección`,
  GW_PARTICIPANTS: `Participantes`,
  GW_ZONES: `Zonas`,
  GW_STEP: `Etapa`,
  GW_STEPS: `Etapas`,
  GW_STEP_TEAM_HINT: `Al añadir equipos aquí, podrá compartir con ellos el resumen de esta inspección sobre el terreno.`,
  GW_GOAL: `Objetivo`,
  GW_CHECKLIST: `Lista de verificación`,
  GW_CHECKLIST_ITEM: `Punto de la lista`,
  GW_NEW: `Nueva`,
  GW_OLD: `Antigua`,
  GW_NEW_COMMENTS: `Nuevos comentarios`,
  GW_ADD_COMMENT: `Añadir un comentario`,
  GW_VALIDATE_STEP: `Confirmar la etapa`,
  GW_INVALIDATE_STEP: `Invalidar la etapa`,
  GW_IS_COMPLETE: `terminada`,
  GW_TEAM_SUMMARY_INTRO: `La inspección sobre el terreno "{name}" tuvo lugar el {date}. `,
  GW_TEAM_SUMMARY_CHECKS: `No ha habido ningún control.|En {nItems} control, <span class="ok-green">{nOk} OK</span> y <span class="nok-red">{nNok} NOK</span>.|En {nItems} controles, <span class="ok-green">{nOk} OK</span> y <span class="nok-red">{nNok} NOK</span>.`,
  GW_TEAM_MSG_DISPLAY: `Mostrar el mensaje principal`,
  GW_TEAM_MSG_DISPLAY_CUSTOM: `Mostrar un mensaje personalizado`,
  GW_TEAM_MSG_HINT: `Puede seleccionar aquí los equipos a los que desea enviar un breve resumen de la inspección. También puede introducir un mensaje personalizado por equipo.<br/>Los mensajes enviados desde esta ventana aparecerán en la página de información de los equipos.<br/>Si no desea enviarles ningún mensaje, desmarque las casillas correspondientes (las casillas pueden marcarse o desmarcarse de forma predeterminada desde los ajustes).`,
  GW_TEAM_MSG_NONE: `No se ha auditado ningún equipo en esta inspección. Puede añadir equipos que auditar desde la página de la plantilla de esta inspección.`,
  GW_TEAM_SEND: `Enviar a {teamName}`,
  GW_END_GW: `Terminar la inspección`,
  GW_TEAM_LINKED_TO_STEP: `Equipo asociado a la etapa`,
  GW_NO_LINKED_TEAM: `Ningún equipo asociado`,
  GW_NO_TEAM_IN_TEMPLATE: `No se ha definido ningún equipo en la plantilla de la inspección sobre el terreno.<br/>Defina un equipo si desea obtener acceso a sus problemas y acciones.`,
  GW_NO_NAME: `No se ha atribuido ningún nombre`,
  GW_FETCH_PROBLEMS: `Cargar los problemas`,
  GW_FETCH_ACTIONS: `Cargar las acciones en curso`,
  GW_STEP_PREVIOUS: `Etapa de la inspección anterior`,
  GW_SUMMARY: `Resumen`,
  GW_N_COMMENTS: `0 coms.|1 com.|{n} coms.`,
  GW_N_PROBLEMS: `0 problemas|1 problema|{n} problemas`,
  GW_N_ACTIONS: `0 acciones|1 acción|{n} acciones`,
  GW_CONFIRM_DEL_PB: `¿Seguro que desea eliminar este problema?<br/>Al hacerlo, se eliminarán también todos los datos asociados (causas, acciones, imágenes).`,
  GW_CONFIRM_DEL_ACTION: `¿Desea realmente eliminar esta acción?`,
  GW_SHOW_ALL_PROBLEMS: `Todos los problemas`,
  GW_SHOW_PROBLEMS_FOR: `Problemas de "{step}"`,
  GW_SHOW_ALL_ACTIONS: `Todas las acciones`,
  GW_SHOW_ACTIONS_STEP: `Acciones de "{step}"`,
  GW_SHOW_ACTIONS_OF_PB: `Acciones de un problema`,
  GW_SHOW_ACTIONS_PB: `Acciones de "{pb}"`,
  GW_DISPLAY_COMMENTS: `Mostrar los comentarios`,
  GW_DISPLAY_CHECKLISTS: `Mostrar las listas`,
  GW_SET_ACTION_TEAM: `Defina un equipo para esta acción`,
  GW_NO_PB_SELECTED: `No hay ningún problema seleccionado`,
  GW_SYNTHESIS: `Resumen`,
  GW_DETAILED: `En detalle`,
  GW_STEPS_PROBLEMS: `| Problemas de la etapa | Problemas de las etapas`,
  GW_STEPS_CL_PROBLEMS: `| Problemas de las checklists de la etapa | Problemas de las checklists de las etapas`,
  GW_CONFIRM_DELETE_PLANNING: `¿Seguro que desea eliminar esta planificación?<br/>Al hacerlo, la inspección sobre el terreno dejará de aparecer en la agenda.<br/>Esta operación es irreversible.`,
  GW_NO_STEPS: `No se ha creado ninguna etapa. Añada al menos una para iniciar una inspección sobre el terreno`,
  GW_NO_ACCESS_PLANNING: `No puede modificar la planificación de otro equipo.`,
  GW_PLANNING_DELETED: `Planificación eliminada`,
  GW_NEW_CL: `Nueva lista`,
  GW_WAS_EDITED_REFRESH: `Se ha modificado la inspección. Haga clic aquí para actualizar.`,
  GW_STATS: `Estadísticas de inspecciones`,
  GW_NOT_APPLICABLE: `No aplicable`,
  GW_OK_ITEMS: `Puntos válidos`,
  GW_NOK_ITEMS: `Puntos no válidos`,
  GW_PICK_LOCATION: `Elegir un lugar`,
  GW_PICK_TEAM: `Elegir un equipo`,
  GW_PICK_USER: `Elegir un usuario`,
  GW_AUDITED_TEAMS: `Equipos auditados`,
  GW_AUDITED_USERS: `Usuarios auditados`,
  GW_AUDITED_USER: `Usuario auditado`,
  GW_PICK_CHECKLIST: `Elegir una lista`,
  GW_TEMPLATES_SHORT: `Plantillas`,
  GW_PICK_TEMPLATE: `Elegir una plantilla`,
  GW_CLICK_TO_SEE_PB: `Haga clic para ver los problemas`,
  GW_CLICK_TO_HIDE_PB: `Haga clic para ocultar los problemas`,
  GW_OVER: `La inspección sobre el terreno está terminada`,
  GW_GOTO_SUMMARY: `Ir al resumen`,
  GW_STAY: `Permanecer en esta página`,
  GW_CANCELLED: `Esta inspección sobre el terreno acaba de cancelarse`,
  GW_PREV_PAGE: `Página anterior`,
  GW_PAGES: `Páginas de inspecciones sobre el terreno`,
  GW_LAST_COMPLETE: `Última inspección sobre el terreno terminada`,
  GW_TEAM_1_LATE_PROBLEMS: `, y lleva retraso.`,
  GW_TEAM_N_LATE_PROBLEMS: `, no hay ninguno con retraso.|, con uno con retraso.|, con {n} con retraso.`,
  GW_TEAM_1_LATE_ACTIONS: `, y lleva retraso.`,
  GW_RATE_REVIEW: `Dar una opinión`,
  GW_PREVIEW_TOUR: `Ver la inspección`,
  GW_SEND_RATING: `Enviar la opinión`,
  GW_PROMPT_RATE_REVIEW: `¿Desea atribuir una calificación y un comentario a esta inspección sobre el terreno?`,
  GW_MOOD: `Impresiones`,
  GW_RELEVANCE: `Pertinencia`,
  GW_RATE_MOOD: `Evalúe sus impresiones sobre esta inspección`,
  GW_RATE_RELEVANCE: `Evalúe la pertinencia de la inspección`,
  GW_RATE_MOOD_QUESTIONS: `¿Cómo ha ido la inspección?<br/>En los intercambios se percibía un respeto mutuo?<br/>¿Cuál ha sido la impresión global de cada participante?`,
  GW_RATE_RELEVANCE_QUESTIONS: `¿Cree que la inspección ha sido útil?<br/>Cuando hizo observaciones, ¿resultaron claras y constructivas?<br/>¿Recibió ayuda allí donde la necesitaba?`,
  GW_RATING_NEEDED_COMMENT: `Deje un comentario para que los participantes de la inspección sepan qué pueden mejorar.`,
  GW_RATING_OPTIONAL_COMMENT: `Puede dejar un comentario si desea hacer llegar una información a los participantes de la inspección.`,
  GW_REVIEW_SAVED: `Se ha guardado su opinión`,
  GW_REVIEWS: `Opinión y comentarios`,
  GW_CANCEL_CONFIRM: `¿Desea realmente eliminar esta inspecciones sobre el terreno?<br/>Al hacerlo, se eliminarán todos los datos asociados.<br/><br/>Esta operación es irreversible.`,
  GW_NOT_FOUND: `No hemos encontrado esta inspección sobre el terreno. Puede que se haya eliminado o que no tenga acceso a ella.`,
  GW_N_ONGOING: `| Tiene una inspección sobre el terreno en curso. | Tiene {nb} inspecciones sobre el terreno en curso.`,
  GW_CANT_SELECT_NO_TEAMS: `Debe elegir un equipo`,
  GW_DEFAULT_TICK_TEAMS_TITLE: `Enviar el resumen de la inspección a los equipos concernidos`,
  GW_DEFAULT_TICK_TEAMS_HINT: `Una vez terminada la inspección, en la ventana de información, marque esta casilla para seleccionar automáticamente todos los equipos concernidos por la inspección sobre el terreno.`,
  GW_DEFAULT_TICK_TEAMS: `Seleccionar todos los equipos de forma predeterminada`,
  GW_DEFAULT_HIDE_PREVIOUS: `Ocultar la sección de la inspección anterior de forma predeterminada`,
  GW_DEFAULT_HIDE_PREVIOUS_HINT: `Al marcar esta opción, al iniciar una inspección sobre el terreno, la sección de la derecha que contiene la información de la inspección anterior se ocultará de forma predeterminada. Siempre podrá abrirla tras haber iniciado la inspección.`,
  GW_INDICATORS: `Indicadores de inspección sobre el terreno`,
  GW_INDIC_ADD: `Añadir un indicador de inspección sobre el terreno`,
  GW_INDIC_CONFIM_DELETE: `¿Desea realmente eliminar este indicador?<br/><br/>Al hacerlo, los valores que ha introducido para este indicador también se eliminarán y ya no podrá ver la curva de evolución de estos valores.`,
  GW_HIDDEN_DAYS_ARE: `Días ocultos`,
  GW_HIDE_WD: `Ocultar los días no laborables`,
  GW_NON_WD: `Días no laborables`,
  GW_CUMULATED_NON_WD: `@:message.GW_CUMULATED_NON_WD_BEGINNING no hay ningún día no laborable por semana | @:message.GW_CUMULATED_NON_WD_BEGINNING hay un día no laborable por semana | @:message.GW_CUMULATED_NON_WD_BEGINNING hay {nb} días no laborables por semana`,
  GW_CUMULATED_NON_WD_BEGINNING: `Al totalizar los días laborables de los equipos seleccionados, `,
  GW_N_NA_ITEMS: `Ningún elemento N/A|1 elemento N/A|{nb} elementos N/A`,
  GW_N_OK_ITEMS: `Ningún elemento OK|1 elemento OK|{nb} elementos OK`,
  GW_N_NOK_ITEMS: `Ningún elemento NOK|1 elemento NOK|{nb} elementos NOK`,
  GW_NOK_ITEMS_PARETO: `Elementos NOK (No OK) más recurrentes`,
  GW_NOK_ITEMS_PARETO_ZONES: `Zonas con más elementos NOK`,
  GW_NOK_ITEMS_PARETO_TEAMS: `Equipos auditados con más elementos NOK`,
  GW_NOK_CHART_MESSAGE: `<b>Atención</b>: Las inspecciones sobre el terreno iniciadas antes del 20 de octubre de 2019 no se tienen en cuenta en este gráfico.`,
  GW_ITEMS_OK_CHART: `Evolución de los porcentajes de 'OK', 'NOK' y 'No aplicable' en el tiempo`,
  GW_PLANNING_CHART: `Cumplimiento del calendario de inspecciones sobre el terreno`,
  GW_OVERALL_STATS: `Distribución general`,
  GW_PLANNED_BUT_NOT_CARRIEDOUT: `Planificada pero no ejecutada`,
  GW_NO_PROBLEMS_STEP: `No hay ningún problema asociado a la etapa`,
  GW_STEP_COMMENTS: `Comentarios de la etapa`,
  GW_STEP_NO_CL: `No hay ninguna checklist en esta etapa`,
  GW_NO_ACCESS: `Su equipo no tiene acceso a esta inspección.`,
  GW_LEAVE_START: `Va a salir de esta página. Al hacerlo, no se guardará ningún cambio realizado en esta inspección.`,
  GW_CONFIRM_REMOVE_STEP: `¿Desea realmente eliminar esta etapa?`,
  GW_NO_STEP_COMMENT: `No hay comentarios para esta etapa.`,
  COPY_OF: `Copia de {sth}`,
  PICK_THEME: `Elija el tema`,
  ZONE_INCLUSIVE: `Incluir las subzonas`,
  TYPE_INCLUSIVE: `Incluir los subtipos`,
  JIRA_TRIGGER: `Señalar un bug`,
  JIRA_TRIGGER_BUGS: `Acceder a los bugs`,
  JIRA_WHAT_TYPE: `Desea enviar:`,
  JIRA_TYPE_BUG: `Un bug`,
  JIRA_TYPE_IMPROVE: `Una mejora`,
  JIRA_DESCRIPTION: `Descripción`,
  JIRA_DESCRITION_HINT: `No dude en indicar el máximo de detalles posible para describir la situación encontrada.<br/>Por ejemplo, puede describirnos los pasos que le han permitido encontrar el bug.`,
  JIRA_ISSUE_REPORTED: `Se ha señalado el problema. Gracias por ponerse en contacto con nosotros, le responderemos en breve.`,
  JIRA_ISSUE_CREATION_ERROR_DESCRIPTION: `Le rogamos que introduzca una descripción para poder enviar su solicitud.`,
  H_TEXT_ALIGN: `Alineación horizontal`,
  V_TEXT_ALIGN: `Alineación vertical`,
  ALIGN_TEXT_WHERE: `Alinear el texto`,
  CENTER_TEXT_WHERE: `Centrar el texto`,
  ALIGN_TEXT_TOP: `@:message.ALIGN_TEXT_WHERE arriba`,
  ALIGN_TEXT_BOT: `@:message.ALIGN_TEXT_WHERE abajo`,
  ALIGN_TEXT_MID: `@:message.CENTER_TEXT_WHERE verticalmente`,
  ALIGN_TEXT_LEFT: `@:message.ALIGN_TEXT_WHERE a la izquierda`,
  ALIGN_TEXT_RIGHT: `@:message.ALIGN_TEXT_WHERE a la derecha`,
  ALIGN_TEXT_CENTER: `@:message.CENTER_TEXT_WHERE horizontalmente`,
  CFG_PAGES: `Páginas configurables`,
  PAGE: `Página`,
  WIDGET: `Widget`,
  WIDGETS: `Widgets`,
  CFG_PAGE_CONFIG: `Ajustes de la página`,
  CFG_PAGE_WIDGET_CONFIG: `Ajuste del widget`,
  CFG_PAGE_SPEC_CONFIG: `Ajustes específicos`,
  CUST_PAGES_N_WIDGET: `(Ningún widget)|(1 widget)|({n} widgets)`,
  CUST_PAGES_NEW: `Nueva página configurable`,
  CFG_PAGES_CREATED: `Página añadida`,
  CFG_PAGES_DELETED: `Página eliminada`,
  CFG_PAGES_CONFIRM_DELETE: `¿Desea eliminar esta página?`,
  CFG_PAGES_HINT_ADD_WIDGET: `Añadir widgets arrastrando elementos desde el panel de la derecha.`,
  CFG_PAGE_NAME: `Nombre de la página`,
  CFG_PAGE_ADD_MENU: `Añadir la página al menú`,
  CFG_PAGE_PREVIEW: `Vista previa de la página`,
  CFG_PAGE_ALLOW_TEAM_CREATING_TEMPLATE: `Permitir a los equipos crear plantillas a partir de sus propias páginas`,
  CFG_PAGE_MAKE_TEMPLATE: `Cree una plantilla desde esta página`,
  CFG_PAGE_ALREADY_HAS_TEMPLATE: `Ya existe una plantilla para esta página`,
  CFG_PAGE_COLOR: `Color de fondo`,
  CFG_PAGE_NO_WIDGET_SELECTED: `No hay ningún widget seleccionado. Haga clic en un widget para modificarlo.`,
  CFG_PAGE_DUPLICATE_WIDGET: `Duplicar el widget`,
  CFG_PAGE_LIBRARY_INDIC_HINT: `El campo de arriba le permite elegir un indicator de la biblioteca. Al asignar esta página a un equipo, Shizen buscará el indicador elegido entre los indicadores de este equipo y lo mostrára en el widget.`,
  FILTER_CFG_PAGES: `Filtrar las páginas configurables`,
  CFG_PAGE_LOCK_IMPORT: `Bloquear la página`,
  CFG_PAGE_LOCK_IMPORT_HINT: `Al bloquear esta página, los equipos no podrán importarla desde sus ajustes. Sin embargo, se puede asignar la página a cualquier equipo desde la config.`,
  CFG_PAGE_SYNCED: `Sincronizar la página`,
  CFG_PAGE_SYNCED_HINT: `Si se activa la sincronización, los cambios realizados en esta página también actualizarán las páginas de los equipos que la utilizan. Además, los equipos no podrán modificar los widgets existentes, pero podrán añadir otros nuevos.`,
  CFG_PAGE_CANT_EDIT_TEMPLATE_WIDGET: `La sincronización esta activada en esta página y este widget forma parte de la plantilla. No se puede modificar.`,
  CFG_PAGES_IMPORT_TEMPLATE: `Importar una plantilla`,
  CFG_PAGE_SNAPPING: `Ancra de los widgets`,
  CFG_PAGE_SNAPPING_SPACE: `cada`,
  CFG_PAGE_SNAP_EACH_OTHER: `de los unos a los otros`,
  CFG_PAGE_SNAP_GRID: `a una cuadrícula`,
  CFG_W_DESIGN_OPTIONS: `Opciones de apariencia`,
  CFG_W_INNER_MARGIN: `Margen interior`,
  CFG_W_INNER_MARGIN_HINT: `El margen máximo es de 10`,
  CFG_W_BORDER: `Borde`,
  CFG_W_ROUNED_CORNER: `Esquinas redondeadas`,
  WIDGET_DELETE: `Eliminar el widget`,
  WIDGET_CONFIRM_DELETE: `¿Eliminar el widget?`,
  WIDGET_NAME_TEXT: `Párrafo de texto`,
  WIDGET_NAME_TEXT_PER_DATE: `Entrada de texto por fecha`,
  WIDGET_NAME_PENDING: `Lista de acciones en espera`,
  WIDGET_NAME_BUTTON: `Enlace a otro sitio`,
  WIDGET_HELP: `Mueva este elemento con el ratón y cambie su tamaño mediante las esquinas azules.`,
  WIDGET_TEXT_CONTENT: `Contenido`,
  WIDGET_TEXT_SIZE: `Tamaño del texto`,
  WIDGET_TEXT_FONT_HINT: `El tamaño del texto será {mult} veces el tamaño de la fuente de Shizen.`,
  WIDGET_TEXT_ALLOW_EDIT: `Contenido modificable`,
  WIDGET_TEXT_ALLOW_SCROLL: `Contenido con desplazamiento`,
  WIDGET_TEXT_ADAPT_FONT_SIZE: `Adaptar el tamaño de la fuente al tamaño del widget`,
  WIDGET_PICTS_ONLY_ONE: `Una sola imagen`,
  WIDGET_PICTS_EDITABLE: `Imágenes editables fuera del modo de edición`,
  WIDGET_PICTS_EDITABLE_HINT: `Al seleccionar esta opción, la interacción con los documentos PDF ya no será posible.`,
  IMAGES: `Imágenes`,
  IMAGES_AND_DOCS: `Imágenes y documentos`,
  WIDGET_SHOW_ICON: `Mostrar el icono del sitio`,
  WIDGET_PLANS_OF_CURRENT_TEAM: `Sus planes`,
  WIDGET_NO_PLANS_SELECTED: `No hay ningún plan de acción seleccionado`,
  WIDGET_INDIC_CUULATED: `Indicador totalizado`,
  WIDGET_INDIC_DISPLAY_RANGE: `Mostrar el editor de periodo`,
  WIDGET_INDIC_GAP_DAYS: `Desfase (en días)`,
  WIDGET_INDIC_HINT_ONEDAY: `Hoy, este indicador mostraría el valor del {day}`,
  WIDGET_INDIC_HINT_RANGE: `Hoy, este indicador mostraría los valores del {start} al {end}`,
  WIDGET_INDIC_NO_SELECTED: `No hay ningún indicador seleccionado`,
  WIDGET_INDICS_OF_CURRENT_TEAM: `Sus indicadores`,
  WIDGET_DETAILED_DETAILS: `Mostrar los detalles`,
  WIDGET_DETAILED_ANALYSIS: `Mostrar el análisis`,
  WIDGET_DETAILED_PB_ACTIONS: `Mostrar los problemas y las acciones`,
  WIDGET_PB_LIST: `Lista de problemas`,
  WIDGET_PB_SORT: `Opciones de ordenación`,
  WIDGET_NAME_VIEWER: `Visor (PDF, vídeo)`,
  WIDGET_VIEWER_WHAT: `Mostrar`,
  WIDGET_VIEWER_PDF: `Archivo PDF`,
  WIDGET_VIEWER_VIDEO: `Vídeo`,
  WIDGET_VIEWER_ADDRESS: `Dirección URL`,
  WIDGET_VIEWER_HTTPS: `https://`,
  WIDGET_VIEWER_LOADING: `Carga del contenido externo...`,
  WIDGET_VIEWER_NOT_VALID: `El enlace URL no parece funcionar. El widget permite mostrar vídeos de YouTube, dailymotion y Vimeo.`,
  WIDGET_VIEWER_MISSING_ADDRESS: `Añada la dirección URL.`,
  WIDGET_VIEWER_UPLOAD_PDF: `Cargar desde el dispositivo`,
  WIDGET_NAME_WHEEL: `Vista mensual de indicadores`,
  WIDGET_WHEEL_NO_THEME: `Ningún tema seleccionado`,
  WIDGET_WHEEL_HIDE_CONTROLS: `Ocultar los controles de navegación`,
  WIDGET_WHEEL_HIDE_INFO: `Ocultar los datos adicionales`,
  WIDGET_NAME_PAGES_SLIDESHOW: `Presentación de diapositivas de páginas`,
  SLIDESHOW_CONTROLS: `Mostrar las flechas de navegación`,
  SLIDESHOW_AUTO_SCROLL: `Desplazamiento automático`,
  SLIDESHOW_LIMIT_REACHED: `Solo puede haber un máximo de 2 presentaciones de diapositivas por página.`,
  SLIDESHOW_NESTED_EMBED: `No se puede mostrar el contenido.<br/>Un widget de presentación de diapositivas no puede contener otro widget de presentación de diapositivas.`,
  SLIDESHOW_ALLOW_INTERACTION: `Permitir la interacción con el contenido del widget`,
  WIDGET_NAME_STICKERS: `Notas adhesivas`,
  WIDGET_TEXT_PER_DATE_PERIOD_HINT: `Este campo le permite elegir la unidad de tiempo que desea utilizar para desplazarse entre períodos.`,
  WIDGET_PROBLEMS_SHOW_DELETE_BTN: `Mostrar el botón "eliminar" en los problemas`,
  IDC_CHART: `Configuración de los gráficos`,
  IDC_AVAILABLE: `Configuraciones disponibles`,
  IDC_NEW: `Nueva configuración`,
  IDC_EDITION: `Edición de la configuración`,
  IDC_PRESETS: `Preajustes`,
  IDC_NAME: `Nombre de la configuración`,
  IDC_POINT_PERIOD: `Periodo de un punto`,
  IDC_SIMPLIFIED_PRESETS_HINT: `El modo simplificado permite elegir entre los siguientes preajustes. Al hacer clic en un preajuste, la configuración se actualizará automáticamente.<br/>Sin embargo, si necesita opciones más específicas, puede cambiar al modo avanzado.`,
  IDC_POINT_PERIOD_HINT: `En el nuevo gráfico, un punto totalizará los valores de {period} del gráfico normal.`,
  IDC_CHART_PERIOD: `Extensión visible del gráfico`,
  IDC_CHART_PERIOD_HINT: `Mostrará una extensión total de {period}.`,
  IDC_INCR_CUMUL_VALUES: `Valores totalizados crecientes`,
  IDC_INCR_CUMUL_VALUES_HINT: `Los valores aumentarán desde el inicio de cada intervalo de totalización hasta su final.`,
  IDC_INCREASE_INTERVAL: `Intervalo de totalización de valores`,
  IDC_INCREASE_PERIOD_HINT: `Los valores aumentarán en intervalos de {period}.`,
  IDC_INCR_CUMUL_OBJ: `Objetivos totalizados crecientes`,
  IDC_INCR_CUMUL_OBJ_HINT: `Los objetivos aumentarán de la misma forma que los valores.`,
  IDC_USE_FIXED_END_DATE: `Establecer una fecha de finalización fija para el gráfico`,
  IDC_END_DATE: `Fecha de finalización del gráfico`,
  IDC_CURRENT_DATE: `Fecha actual`,
  IDC_CURRENT_DATE_GAP: `Fecha actual con un desfase`,
  IDC_FIXED_END_DATE: `Fecha fija de finalización del gráfico`,
  IDC_END_DATE_HINT: `Al utilizar una fecha fija para el final del gráfico, no podrá cambiar el periodo manualmente. Los valores mostrados en su gráfico serán siempre los mismos.<br>También puede elegir la fecha actual con un desfase para mostrar por defecto la semana o el mes anterior, por ejemplo.`,
  IDC_PRESET_1: `Valores crecientes por periodo de 1 mes. Objetivo estático.`,
  IDC_PRESET_2: `Valores crecientes por periodo de 1 mes. Objetivo creciente.`,
  IDC_PRESET_3: `Indicador semanal (valores totalizados en una semana).`,
  IDC_PRESET_4: `Valores de la semana pasada.`,
  IDC_PRESET_5: `Valores acumulados crecientes de la semana pasada.`,
  IDC_SAVING: `Guardado...`,
  IDC_SAVED: `Configuración guardada`,
  IDC_CUSTOM: `Configuraciones personalizadas`,
  IDC_CONFIG_IS_DEFAULT: `Esta configuración se define de forma predeterminada y se puede modificar.`,
  IDC_DETAILED_INDIC_HINT: `NOTA: En la página de un indicador detallado, la extensión del gráfico será de 365 días.`,
  WIDGET_IMAGE_SIZE: `Tamaño de la imagen`,
  TITLE: `Título`,
  WIDGET_BUTTON_LINK: `Enlace`,
  RECURRENCE: `Recurrencia`,
  NO_PB_FOUND: `No se ha encontrado ningún problema`,
  COMPARING_NB_OF_TOTAL: `Comparación de {nb} en {total}`,
  SIMILAR_PBS: `Problemas similares`,
  SIMILARITIES_FIELDS: `Similitudes en {fieldsWord} {fieldsList}`,
  FIELDS_SUFFIX: `el campo | los campos`,
  NO_SIMILARITY: `Ninguna similitud`,
  RECURRENCE_DUPLICATE: `Idéntico`,
  RECURRENCE_DUPLICATE_SHORT: `Ide.`,
  RECURRENCE_DUPLICATE_HINT: `Marque esta casilla si cree que se trata de problemas idénticos o casi idénticos, por lo que entender el primero debería ayudar a resolver el segundo.`,
  RELATED: `En relación`,
  RELATED_SHORT: `Asociado`,
  RELATED_HINT: `Marque esta casilla si los problemas están asociados y puede haber causas o acciones comunes.`,
  RECURRENCE_N_DUPLICATE: `Ningún problema idéntico | 1 problema idéntico | {nb} problemas idénticos`,
  RECURRENCE_N_RELATED: `Ningún problema en relación | 1 problema en relación  | {nb} problemas en relación`,
  DISPLAY_QUICK_FILTERS: `Mostrar los filtros rápidos`,
  QFILTER_MY_TEAM: `Mi equipo`,
  QFILTER_OTHER_TEAMS: `Otros equipos`,
  QFILTER_RESOLVED: `Resueltos`,
  QFILTER_NOT_RESOLVED: `No resueltos`,
  QFILTER_ARCHIVED: `Archivados`,
  QFILTER_NOT_ARCHIVED: `No archivados`,
  SIMILARITY_PERC_NEO: `Neo ha encontrado una similitud del {perc} % entre estos dos problemas`,
  PB_DUPLICATE_MERGE_CONFIRM: `Estos dos problemas son idénticos a problemas diferentes. ¿Desea fusionar las relaciones de recurrencia para que todos los problemas se consideren idénticos?`,
  PB_DUPLICATE_MERGE: `Fusionar`,
  SCREEN_SAVER: `Protector de pantalla`,
  ENABLE_SCREEN_SAVER: `Activar el protector de pantalla`,
  SCREEN_SAVER_TIMEOUT: `Iniciar el protector de pantalla después`,
  KEEP_SCREEN_SAVER_PAGE: `Permanecer en la última página del protector de pantalla`,
  PAGES: `Páginas`,
  ADD_PAGE: `Añadir una página`,
  SOCKET_CONNECTING: `La sincronización está en preparación.`,
  SOCKET_READY: `La sincronización está activa.`,
  SOCKET_CLOSED: `La sincronización se ha cerrado. Haga clic para reiniciarla.<br>Si se abre una pestaña al hacer clic, el navegador puede pedirle autorizar la conexión con un certificado SSL.<br>Si es así, solo podrá efectuarse la conexión si la acepta.`,
  INDICATORS_LIBRARY: `Biblioteca de indicadores`,
  CONFIG_COLLAPSE_ALL: `Cerrar todo`,
  CONFIG_EXPAND_ALL: `Abrir todo`,
  NAME_PH: `Nombre...`,
  THEME_NAME_PH: `Nombre del tema...`,
  LIBRARY_INDIC_UNCATEGORIZED: `Sin categoría`,
  LIBRARY_INDIC_MERGE: `Fusionar con...`,
  LIBRARY_INDIC_MOVE: `Mover`,
  LIBRARY_INDIC_HINT: `Esta página muestra todos los indicadores de la empresa.<br/>Puede añadir estos indicadores a los paneles de sus equipos accediendo a sus ajustes o aplicándoles una plantilla. Para cada uno de los siguientes indicadores, puede ver el número de equipos a los que se han asignado.<br/><br/>Tener una sola referencia para un indicador presente en varios equipos permite a los gestores ver los valores totalizados en un solo gráfico.<br/>También puede crear una plantilla para disponer de un preajuste en la página de indicadores totalizados o asignar un conjunto de indicadores a varios equipos rápidamente.`,
  LIBRARY_INDIC_MERGE_HINT: `Al fusionar dos indicadores, puede mostrar una vista global con los valores totalizados de varios equipos. Si ha creado dos indicadores para hacer un seguimiento de accidentes, por ejemplo, puede fusionarlos para que la página de gestión de indicadores muestre la suma de accidentes.<br/>Fusionar dos indicadores de la biblioteca no afectará a los indicadores de los equipos.`,
  LIBRARY_INDIC_MERGE_SAME: `No es posible fusionar un indicador consigo mismo.`,
  LIBRARY_INDIC_DELETE_THEME_CONFIRM: `¿Desea realmente eliminar esta categoría?<br/>Al hacerlo, todos los indicadores relacionados se añadirán a los indicadores sin categoría.<br/>Los equipos relacionados con los indicadores de este tema no se verán afectados.`,
  LIBRARY_INDIC_DELETE_CONFIRM: `¿Desea realmente eliminar este indicador?<br/>Al hacerlo, se archivarán todos los indicadores relacionados.`,
  LIBRARY_INDIC_USED_BY: `No utilizado|Utilizado por 1 equipo|Utilizado por {n} equipos`,
  LIBRARY_INDIC_USE_AVERAGE: `Calcular la media en lugar de totalizar los valores`,
  LIBRARY_INDIC_AVERAGE_HINT: `En lugar de totalizar los indicadores, puede resultar más útil calcular una media de los valores, especialmente al trabajar con porcentajes, por ejemplo.<br/>Cuando lo necesite, bastará con marcar esta casilla para mostrar una media en lugar de un valor totalizado.`,
  GW_OVERLAY: `Ventana de inspecciones sobre el terreno en curso`,
  HIDE_GW_OVERLAY: `Esta es la ventana de inspecciones sobre el terreno en curso`,
  RESET_GW_OVERLAY: `Restablecer la ventana de inspecciones sobre el terreno en curso`,
  NOTICE_GW_OVERLAY_IGNORE: `¿Seguro que desea ignorar todas las inspecciones sobre el terreno en curso?<br><br>Esta ventana volverá a abrirse en la próxima inspección sobre el terreno. También puede volver a abrirla en los ajustes`,
  NAVIGATION_MENU: `Menú de navegación`,
  MENU: `Menú`,
  SHORTCUTS: `Shortcuts`,
  ADD_A_LINK: `Añadir un enlace`,
  RESET_DEFAULT: `Restablecer predeterminado`,
  RESET: `Restablecer`,
  RESET_SUCCESS: `Restablecimiento con éxito`,
  NAVIGATION_RESET_CONFIRM: `¿Seguro que quiere restablecer el menú de navegación predeterminado?`,
  NAVIGATION_CUSTOMIZE: `Personalizar la barra de navegación`,
  NAVIGATION_LOCKED: `Este elemento está bloqueado. No es posible quitarlo.`,
  FILE_UPLOAD_SUCCESS: `Archivo guardado | {nb} archivos guardados`,
  FILE_UPLOAD_ERROR: `Error al enviar un archivo`,
  FILE_UPLOAD_ERROR_SIZE: `El archivo supera el límite de 20 MB`,
  FILE_UPLOAD_ERROR_FORMAT: `Este formato de archivo no es compatible (*.pdf, *.bmp, *.gif, *.jpg, *.png, *.xls, *.xlsx, *.ods, *.doc, *.docx, *.odt, *.ppt, *.odp)`,
  FILE_UPLOAD_ERROR_QUOTA: `Su equipo ha sobrepasado el límite de 100 MB de Shizen`,
  FILE_DELETE_CONFIRM: `¿Seguro que desea eliminar este archivo?<br>Si el archivo se utiliza en una información, un problema o una acción, al eliminarlo se quitará de todas las páginas donde se utilice | ¿Seguro que desea eliminar estos archivos?<br>Si los archivos se utilizan en una información, un problema o una acción, al eliminarlos se quitarán de todas las páginas donde se utilicen`,
  FILE_DELETE_SUCCESS: `Archivo eliminado correctamente  | {nb} archivos eliminados correctamente`,
  FILE_DELETE_ERROR: `Error al eliminar el archivo`,
  FILE_DELETE_ERROR_NO_ACCESS: `Su equipo no tiene acceso a este archivo`,
  FILE_REF_COUNT: `No utilizado en Shizen | Utilizado una vez en Shizen | Utilizado {nb} veces en Shizen`,
  FILES: `Archivos`,
  ADD_FILES: `Añadir archivos`,
  HOW_ADD_FILES: `¿Cómo desea añadir archivos?<br>Puede reutilizar archivos que usted u otro miembro de la empresa haya añadido anteriormente o añadir nuevos archivos.<br><br>También puede pegar una imagen desde el portapapeles.`,
  SEARCH_ON_DATABASE: `Buscar en Shizen`,
  PASTE_HERE: `Pegar una imagen aquí`,
  PASTE_HERE_SHORTCUT: `Ctrl + V`,
  PREVIEW: `Previsualizar`,
  DOWNLOAD: `Descargar`,
  CONFIRM_DELETE_FILE: `¿Desea eliminar el archivo?`,
  NO_PREVIEW: `No hay vista previa disponible`,
  SCHEDULE_PLANNING_ERROR: `Error de planificación. Parece que no es posible planificar esta reunión.`,
  INFO_AT_DATE: `Información mostrada en esta fecha ({nb})`,
  NO_INFO_AT_DATE: `Ninguna información mostrada en esta fecha`,
  ISHI_BRANCH_ENVIRONMENT: `Medio`,
  ISHI_HINT: `Le damos la bienvenida a la herramienta de diagrama de Ishikawa. Utilice esta herramienta para listar y estructurar todas las causas posibles que entrañan un efecto.<br>Puede crear una nueva causa haciendo clic en el botón "Añadir una causa" en la base de una de las ramas. Puede crear una "subcausa" de una causa (la causa de otra causa) haciendo clic en el botón "+" que aparece junto a esta.<br>Si desea mover un elemento de una rama a otra, puede arrastrarlo y soltarlo sobre el nombre de una rama o de otra causa.`,
  ISHI_BRANCH_MATERIALS: `Materiales`,
  ISHI_BRANCH_MACHINES: `Máquinas`,
  ISHI_BRANCH_METHODS: `Métodos`,
  ISHI_BRANCH_MEN: `Mano de obra`,
  ISHI_BRANCHLESS_CAUSES: `Causas no clasificadas`,
  ISHI_NO_BRANCHLESS_CAUSES: `No hay causas no clasificadas`,
  REMOVE_ANNOUNCEMENT: `Quitar el anuncio`,
  DISP_ALL_ANNOUNCEMENTS: `Mostrar los anuncios en curso de Shizen`,
  DISP_ANNOUNCEMENTS_HINT: `Si ha cerrado un anuncio y no le ha dado tiempo a leerlo, puede volver a mostrarlo haciendo clic aquí.`,
  CURRENT_CLOSED_ANNOUNCEMENTS: `Anuncios en curso cerrados`,
  SHOW_DETAILS: `Mostrar los detalles`,
  HIDE_DETAILS: `Ocultar los detalles`,
  VISIBLE_CHART_PERIOD: `Periodo visible de los gráficos`,
  CHART_POINT_PERIOD: `Periodo de un punto de los gráficos`,
  DAILY_INDICATORS: `Indicadores diarios`,
  DAILY_INDICATORS_OVER_THIRTY_DAYS: `@:message.DAILY_INDICATORS durante 30 días`,
  DAILY_INDICATORS_DAY_VALUE: `@:(message.DAILY_INDICATORS): Valor del día`,
  DAILY_INDICATORS_YESTERDAY_VALUE: `@:(message.DAILY_INDICATORS): Valor de ayer`,
  WEEKLY_INDICATORS: `Indicadores semanales`,
  MONTHLY_INDICATORS: `Indicadores mensuales`,
  PERIOD_START_DAY: `Día de inicio del periodo`,
  DEFAULT_PRESETS: `Preselecciones predeterminadas`,
  CUSTOM_PRESETS: `Preselecciones personalizadas`,
  MANAGE_PRESETS: `Gestionar las preselecciones`,
  HISTORY: `Historial`,
  DELETED_PLACEHOLDER: `[Elemento eliminado]`,
  HISTORY_EMPTY: `El historial está vacío.`,
  HISTORY_THE_TEAM: `El equipo "{team}" {didWhat}`,
  HISTORY_THE_TEAM_AND_USER: `{user} ({team}) {didWhat}`,
  HISTORY_CREATION_PB: `ha notificado un problema ("{title}")`,
  HISTORY_CREATION_CAUSE: `ha creado una causa ("{title}")`,
  HISTORY_CREATION_ACTION: `ha creado una acción ("{title}")`,
  HISTORY_DELETION_CAUSE: `ha eliminado una causa`,
  HISTORY_DELETION_ACTION: `ha eliminado una acción`,
  HISTORY_EDIT_PB: `ha modificado <b>{field}</b> del problema`,
  HISTORY_FIELD_PB_LWHAT: `el campo "qué"`,
  HISTORY_FIELD_PB_LWHO: `el campo "quién"`,
  HISTORY_FIELD_PB_LWHERE: `el campo "dónde"`,
  HISTORY_FIELD_PB_LWHEN: `el campo "cuándo"`,
  HISTORY_FIELD_PB_LHOW: `el campo "cómo"`,
  HISTORY_FIELD_PB_LHOWMUCH: `el campo "cuánto"`,
  HISTORY_FIELD_PB_LWHY: `el campo "por qué"`,
  HISTORY_FIELD_PB_IMPACT: `El impacto`,
  HISTORY_FIELD_PB_TYPES: `los tipos`,
  HISTORY_FIELD_PB_ZONES: `los lugares`,
  HISTORY_FIELD_PB_INDICATORS: `los indicadores asociados`,
  HISTORY_FIELD_PB_KEYWORDS: `las palabras clave`,
  HISTORY_FIELD_PB_DEADLINE: `el plazo`,
  HISTORY_FIELD_PB_LEADERS: `el responsable`,
  HISTORY_FIELD_PB_FILES: `los archivos`,
  HISTORY_FIELD_PB_CAUSE: {
    TEXT: `el contenido @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    FILES: `los archivos @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    CAUSE: `la causa principal @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISHIKAWABRANCH: `la rama Ishikawa @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    HIDEINSHEET: `la visibilidad de las causas`,
    ISVERIFIED: `el estado verificado @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISREAL: `el estado real @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
  },
  HISTORY_FIELD_PB_CAUSE_SUFFIX: `de una causa`,
  HISTORY_FIELD_PB_ACTION: {
    NAME: `@:message.HISTORY_FIELD_ACTION_NAME @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    CAUSE: `@:message.HISTORY_FIELD_ACTION_CAUSE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    LEADER: `@:message.HISTORY_FIELD_ACTION_LEADER @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    IMPACT: `@:message.HISTORY_FIELD_ACTION_IMPACT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PDCA: `@:message.HISTORY_FIELD_ACTION_PDCA @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAIN: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    DEADLINE: `@:message.HISTORY_FIELD_ACTION_DEADLINE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    COMMENT: `@:message.HISTORY_FIELD_ACTION_COMMENT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    FILES: `@:message.HISTORY_FIELD_ACTION_FILES @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PLAN: `@:message.HISTORY_FIELD_ACTION_PLAN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    STATE: `@:message.HISTORY_FIELD_ACTION_STATE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PROBLEM: `@:message.HISTORY_FIELD_ACTION_PROBLEM @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
  },
  HISTORY_FIELD_PB_ACTION_SUFFIX: `de una acción`,
  HISTORY_FIELD_PB_CREATED: `la fecha de creación`,
  HISTORY_EDIT_ACTION: `ha modificado <b>{field}</b> de la acción.`,
  HISTORY_FIELD_ACTION_NAME: `el nombre`,
  HISTORY_FIELD_ACTION_CAUSE: `la causa asociada`,
  HISTORY_FIELD_ACTION_LEADER: `el responsable`,
  HISTORY_FIELD_ACTION_IMPACT: `El impacto`,
  HISTORY_FIELD_ACTION_PDCA: `el PDCA`,
  HISTORY_FIELD_ACTION_GAIN: `los beneficios`,
  HISTORY_FIELD_ACTION_GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN`,
  HISTORY_FIELD_ACTION_DEADLINE: `el plazo`,
  HISTORY_FIELD_ACTION_COMMENT: `los comentarios`,
  HISTORY_FIELD_ACTION_FILES: `los archivos`,
  HISTORY_FIELD_ACTION_PLAN: `el plan de acción`,
  HISTORY_FIELD_ACTION_STATE: `el estado`,
  HISTORY_FIELD_ACTION_PROBLEM: `el problema`,
  SETTINGS_USER_DATA_USAGE: `En Shizen se utilizan el nombre, los apellidos, la fotografía y el email de cada usuario.<ul><li>El nombre, los apellidos y la fotografía permiten a todos los demás usuarios identificar rápidamente a los responsables de las acciones, los problemas y otros elementos del producto.</li><li>El email permite a quienes lo deseen recibir notificaciones durante ciertas acciones específicas, como el envío de acciones, la puesta en común de fichas de problema, etc.</li></ul>Estos datos nunca se utilizan fuera de Shizen, ni se comunican a terceros.<br>Puede solicitar que se anonimicen sus datos desde esta página, haciendo clic en el botón "Eliminar". Al hacerlo, se enviará una solicitud directamente a los administradores de Shizen, que podrán eliminar todos los datos relacionados con usted.`,
  ERASE: `Borrar`,
  CONFIRM_USER_DATA_REMOVAL_REQUEST: `Al hacer clic en el siguiente botón, enviará una solicitud de supresión de los datos de este usuario. La supresión o anonimización de estos datos deberá efectuarlas el responsable del equipo o el administrador, a quien se notificará por correo electrónico.\n¿Desea confirmar esta acción?`,
  USER_DATA_REMOVAL_DATE: `Este usuario ha realizado una solicitud de supresión el {date}`,
  ERASE_USER_DATA: `Borrar los datos del usuario`,
  CONFIRM_ERASE_USER_DATA: `¿Seguro que desea eliminar los datos del usuario?\nAl hacerlo, el usuario seguirá existiendo, pero se eliminarán sus apellidos, nombre, dirección de correo electrónico y fotografía.`,
  CANCEL_USER_DATA_REMOVAL_REQUEST: `Cancelar la solicitud de supresión`,
  FOR_A_TOTAL_OF: `para un total de {what}`,
  OUT_OF_WHAT: `de {what}.`,
  MAYBE_LATER: `Más tarde`,
  DONT_ASK_AGAIN: `No volver a preguntar`,
  DISPLAY_ALL_GROUPS: `Mostrar todos los grupos`,
  VITALITY_HUB: `Centro de vitalidad`,
  VITALITY: `Vitalidad`,
  VITALITY_OVERALL: `Vitalidad general`,
  VH_TEAM_NAME: `Nom d'équipe`,
  VH_TEAMS_VITALITY: `Vitalité des équipes`,
  VH_SCORE: `Score`,
  VH_CRIT_BAD: `à analyser`,
  VH_CRIT_INADEQUATE: `à corriger`,
  VH_CRIT_ACCEPTABLE: `à améliorer`,
  VH_CRIT_GOOD: `à perfectionner`,
  VH_DELTA_INCREASE: `Hausse de {val} point | Hausse de {val} points`,
  VH_DELTA_DECREASE: `Baisse de {val} point | Baisse de {val} points`,
  VH_DELTA_NEITHER: `Pas de hausse ni de baisse`,
  VH_HIDE_DETAILS: `Cacher les détails`,
  VH_DISPLAY_DETAILS: `Afficher les détails`,
  VH_VITALITY_OVER_LAST_PERIODS: `Vitalité au cours des 6 dernières périodes`,
  VH_CRITERIA_OVER_LAST_PERIODS: `Répartition des critères au cours des 6 dernières périodes`,
  VH_DISPLAY_GROUPS: `Groupes à afficher`,
  VH_DISPLAY_CATEGORY: `Thématiques à afficher`,
  VH_DISPLAY_CRITERIA_ALL: `Tous`,
  VH_OPTIONS_FILTERS: `Options et filtres`,
  VH_FILTER_BY_CRITICALITY: `Filtrer par criticité`,
  VH_NO_FILTERED_CRITERIA: `Aucun critère à afficher avec ces filtres.`,
  VH_ADD_GROUP: `Ajouter un nouveau groupe d'équipes`,
  VH_NEW_GROUP: `Nouveau groupe`,
  VH_CONFIRM_DELETE_GROUP: `Voulez-vous vraiment supprimer ce groupe ?`,
  VH_CONFIRM_RESET_GROUPS: `Voulez-vous supprimer le dernier groupe et rétablir les groupes par défaut ?`,
  VH_RESET_GROUPS: `Supprimer et rétablir`,
  VH_DEFAULT_TEAMS_MANAGED: `Équipes managées par {name}`,
  VH_CRITICALITY_TABLE_USAGE: `Cochez/décochez les quatre cases ci-dessous pour afficher/masquer les critères selon leur criticité. Pour agrandir une case et en savoir plus sur lesdits critères, cliquez sur le titre de la case.`,
  VH_DISPLAY_QUICK_HELP: `Afficher le bandeau d'aide`,
  VH_HIDE_QUICK_HELP: `Cacher le bandeau d'aide`,
  VH_DISPLAY_HELP: `Afficher l'aide complète du Centre de Vitalité`,
  VH_TIP_SETUP_GROUPS: `Mettez en place les équipes ou groupes d'équipes dont vous voulez voir la vitalité.`,
  VH_TIP_VITALITY: `Pour avoir une vue d'ensemble des équipes qui vont bien et de celles qui ont besoin d'aide.`,
  VH_TIP_CRITERIA: `Et pour vous concentrer sur les critères qui demandent davantage d'attention.`,
  VH_TIP_DETAILS: `Puis affichez plus de détails par catégorie.`,
  VH_PH_GROUP_NAME: `Nom du groupe...`,
  VH_LOADING_WAIT: `Un chargement est déjà en cours. Veuillez attendre quelques instants...`,
  N_TEAMS: `Ningún equipo|1 equipo|{n} equipos`,
  N_USERS: `Ningún usuario|1 usuario|{n} usuarios`,
  DISPLAY_CHART: `Mostrar el gráfico`,
  HIDE_CHART: `Ocultar el gráfico`,
  VH_WHAT_TEAMS: `Equipos`,
  VH_WHAT_PROBLEMS: `Problemas`,
  VH_WHAT_DMP: `datos diarios`,
  VH_WHAT_GEMBAWALKS: `inspecciones sobre el terreno`,
  VH_FINALIZING: `Finalización...`,
  VH_LOADING: `Carge : {what}...`,
  VH_WORKING: `Cálculo de la vitalidad : {what}...`,
  VH_READY: `Carga terminada : {capWhat}`,
  VH_ERROR: `Error durante la carga : {what}...`,
  VH_POINT_INCREASE: `Augmentation de {val} point | Augmentation de {val} points`,
  VH_POINT_DECREASE: `Diminution de {val} point | Diminution de {val} points`,
  VH_DEFAULT_CHART_NAME: `Scores`,
  VH_SHOW_ALL_SENSEI_HINTS: `Afficher les conseils du sensei`,
  VH_SHOW_SENSEI_HINT: `Mostrar la punta`,
  VH_HIDE_SENSEI_HINT: `Ocultar la punta`,
  VH_WELCOME_TOUR: `¡Bienvenido al Centro de Vitalidad!<br>¿Desea una visita guiada?`,
  VH_PB_REL_NUMBER: `Evolución del número de problemas`,
  VH_PB_REL_NUMBER_TEXT: `{val}% de nuevos problemas en comparación con los últimos 5 meses ({nProblems})`,
  VH_PB_SOLVED_REL_NUMBER: `Frecuencia de resolución de problemas`,
  VH_PB_SOLVED_REL_NUMBER_TEXT: `{val}% de problemas resueltos en comparación con los últimos 5 meses ({nProblems})`,
  VH_PB_TRUST: `Índice de confianza medio de los problemas`,
  VH_PB_TRUST_TEXT: `{val}% de índice de confianza de los problemas`,
  VH_PB_CAUSES_IN_COMPLETED: `Causas de los problemas`,
  VH_PB_CAUSES_IN_COMPLETED_TEXT: `El {percVerified}% de los problemas resueltos tienen causas verificadas (el {percAnalysis}% desde el análisis de las causas).\nEl {percLinked}% de las acciones de resolución están vinculadas a causas (el {percLinkedTrue}% a causas reales)`,
  VH_PB_RECURRENCE: `Recurrencia de problemas`,
  VH_PB_RECURRENCE_TEXT: `{val} ocurrencias de "{text}"`,
  VH_PB_NO_RECURRENCE_TEXT: `Aucune récurrence notable parmi ces problèmes`,
  VH_PB_RESOLUTION: `Resolución de problemas`,
  VH_PB_RESOLUTION_TEXT: `En los últimos tres periodos, {nReportedPb} y {nResolvedPb}`,
  VH_PB_RESOLUTION_NO_PROBLEMS: `No se han registrado problemas en los últimos tres periodos`,
  VH_PB_LEAD_TIME: `Tiempo de resolución`,
  VH_PB_LEAD_TIME_TEXT_INC: `Aumento del {val}% del tiempo de resolución ({displayTime})`,
  VH_PB_LEAD_TIME_TEXT_DEC: `Reducción del {val}% del tiempo de resolución ({displayTime})`,
  VH_PB_TYPE_ZONE: `Distribución de los problemas por zonas o tipos.`,
  VH_PB_TYPE_ZONE_TEXT_BOTH: `@:message.VH_PB_TYPE_ZONE_TEXT_ONLY_Z, @:message.VH_PB_TYPE_ZONE_TEXT_ONLY_T`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_Z: `El {zonePerc}% de los problemas se notificaron en "{zoneText}"`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_T: `El {typePerc}% de los problemas están relacionados con "{typeText}"`,
  VH_PB_LATE: `Problemas atrasados`,
  VH_PB_TEXT_NONE_RELATED: `No hay problemas relacionados`,
  VH_PB_LATE_TEXT_NOT_COMPLETED: `{nNotCompletedLate} problema atrasado no completado|{nNotCompletedLate} problemas atrasados no completados`,
  VH_PB_LATE_TEXT_COMPLETED: `{nOnTime} problema completado a tiempo|{nOnTime} problemas completados a tiempo`,
  VH_AC_NUMBER: `Evolución del número de acciones`,
  VH_AC_NUMBER_TEXT: `{val}% de acciones creadas en comparación con los últimos 5 periodos ({nAction})`,
  VH_AC_ABS_NUMBER_TEXT: `{val} acción creada | {val} acciones creadas`,
  VH_AC_LATE: `Acciones tardías`,
  VH_AC_LATE_TEXT_NONE_RELATED: `No hay acciones relacionadas`,
  VH_AC_LATE_TEXT_NOT_COMPLETED: `{nNotActedLate} acción tardía no completada|{nNotActedLate} acciones tardías no completadas`,
  VH_AC_LATE_TEXT_COMPLETED: `{nOnTime} / {nTotalActed} acciones completadas a tiempo`,
  VH_AC_POSTPMT: `Aplazamientos de acciones`,
  VH_AC_POSTPMT_TEXT_NONE_COMPLETED: `No se ha realizado ninguna acción durante este periodo`,
  VH_AC_POSTPMT_TEXT_ACTIONS: `Ninguna acción aplazada|{nActions} acción aplazada {suffix}|{nActions} acciones aplazadas {suffix}`,
  VH_AC_LEAD_TIME: `Plazo de ejecución de las acciones`,
  VH_AC_LEAD_TIME_TEXT_INC: `Aumento del {val}% en el plazo de las acciones ({displayTime})`,
  VH_AC_LEAD_TIME_TEXT_DEC: `Disminución del {val}% en el plazo de las acciones ({displayTime})`,
  VH_GW_ON_SCHEDULE: `Cumplimiento del calendario de inspecciones sobre el terreno`,
  VH_GW_ON_SCHEDULE_NONE_PLANNED: `No hay inspecciones previstas`,
  VH_GW_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} inspecciones completadas`,
  VH_GW_NOK_RECURRENCE: `Recurrencia de elementos NOK durante las inspecciones sobre el terreno`,
  VH_GW_NOK_RECURRENCE_PERCENTAGE: `{perc}% de elementos OK en las inspecciones sobre el terreno. {recurrenceInfo}`,
  VH_GW_NOK_RECURRENCE_TEXT: `{val} ocurrencias de "{text}"`,
  VH_GW_NOK_RECURRENCE_NONE_TEXT: `No hay recurrencia entre estos inspecciones`,
  VH_GW_NONE: `No se han realizado inspecciones sobre el terreno`,
  VH_GW_PB_RECURRENCE: `Recurrencia de problemas durante las inspecciones sobre el terreno`,
  VH_GW_RATINGS: `Evaluación de los equipos auditados`,
  VH_GW_RATINGS_NONE_TEXT: `No se han evaluado las inspecciones sobre el terreno`,
  VH_GW_RATINGS_TEXT: `Las evaluaciones sobre el sentimiento son {mood}/10 y la relevancia {relevance}/10`,
  VH_GW_NOK_WITHOUT_PROBLEM: `Elementos NOK que no están asociados a un problema`,
  VH_GW_NOK_WITHOUT_PROBLEM_TEXT: `El {perc}% de los elementos NOK tienen un problema asociado. ({nWithProblems} / {nTotal})`,
  VH_I_NO_VALUES: `Ningún valor`,
  VH_I_EXCEEDING: `Valores fuera del objetivo`,
  VH_I_EXCEEDING_TEXT: `En total, {nb}/{nValues} superan el objetivo`,
  VH_I_RECURRENCE: `Recurrencia de los rebasamientos de los objetivos`,
  VH_I_RECURRENCE_TEXT: `Objetivo superado {val} veces en "{text}" ({details})`,
  VH_I_RECURRENCE_NONE_TEXT: `Ninguna superación significativa`,
  VH_I_PB: `Número de problemas por indicador`,
  VH_I_PB_TEXT: `{problemsNumber} relacionados con "{text}"`,
  VH_I_PB_NONE_TEXT: `No hay problemas relacionados con los indicadores`,
  VH_I_OUTLIERS: `Valores atípicos de los indicadores`,
  VH_I_OUTLIERS_NONE_TEXT: `No hay valores atípicos para ninguno de los indicadores`,
  VH_I_OUTLIERS_TEXT: `El {perc}% de los indicadores tienen valores atípicos ({nIndicatorsWithOutliers} / {nIndicators})`,
  VH_M_ON_SCHEDULE: `Cumplimiento del calendario de reuniones`,
  VH_M_ON_SCHEDULE_NONE_PLANNED: `Ninguna reunión prevista`,
  VH_M_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} reuniones completadas`,
  VH_M_RATING: `Evaluación de las reuniones`,
  VH_M_NO_RATINGS: `Ninguna evaluación`,
  VH_M_NO_MEETING: `Ninguna reunión completada`,
  VH_M_RATING_TEXT: `La puntuación media de las reuniones es de {value} ({scoreClosest})`,
  VH_M_DURATION: `Duración prevista de las reuniones`,
  VH_M_DURATION_TEXT: `Por término medio, las reuniones difieren en {gap} de la duración prevista`,
  VH_M_PARTICIPANTS: `Asistencia a las reuniones`,
  VH_M_PARTICIPANTS_TEXT: `Por término medio, el {score}% de los participantes previstos asisten a las reuniones.`,
  VH_I_PB_WHEN_RED: `Problemas relacionados con los indicadores fuera de objetivo`,
  VH_I_PB_WHEN_RED_TEXT: `El {score}% de los periodos fuera de objetivo tienen un problema asociado ({nWithProblem} / {nTotal})`,
  VH_I_NO_RED_PERIOD: `Los indicadores nunca se desvían del objetivo`,
  ISSUE_BUGS: `Bugs`,
  ISSUE_IMPROVEMENTS: `Mejoras`,
  ISSUE_NEW_ISSUE: `Nuevo`,
  ISSUE_PENDING: `En espera`,
  ISSUE_ON_GOING: `En curso`,
  ISSUE_FINISHED: `Terminado`,
  ISSUE_REFUSED: `Rechazado`,
  ISSUE_ISSUE_ID: `Número de ticket`,
  ISSUE_CREATION_DATE: `Creado el`,
  AUTHOR: `Autor`,
  FREE_VERSION_RESTRICTED: `No se puede acceder a este contenido desde una versión gratuita. Póngase en contacto con Shizen para obtener más información y obtener acceso a todas las funciones.`,
  GET_FULL_SHIZEN_LINK: `<a class="shizen-upgrade-link" href="https://shizen.io/demo" target="_blank">Obtener la versión completa</a>`,
  GET_FULL_SHIZEN: `Obtener la versión completa`,
  GW_INDICATORS_HINT: `Los indicadores de inspección sobre el terreno permiten a las personas encargadas de las inspecciones ser más precisas a la hora de recabar datos durante sus visitas sobre el terreno. Además, los datos pueden recopilarse y representarse en gráficos a corto y largo plazo para analizar la evolución de los controles de las inspecciones sobre el terreno.`,
  DISPLAY_NEO_HINTS: `Mostrar los consejos de Neo.`,
  INDIC_NEO_REPORT_PROBLEM: `Los 3 últimos valores del indicador incumplen el objetivo.<br>¿Desea notificar un problema al respecto?`,
  DONT_SHOW_AGAIN_TEN_DAYS: `No volver a mostrar durante 10 días`,
  COMING_SOON: `Disponible próximamente`,
  N_MEMBERS: `Ningún miembro | 1 miembro | {nb} miembros`,
  CURRENT_TEAM: `Equipo actual`,
  OTHER_TEAMS: `Otros equipos`,
  ACCOUNT_SWITCHED_TEAM: `Esta cuenta se ha trasferido a otro equipo. Es necesario actualizar ya la página, aunque puede hacerlo más tarde.<br><br>Si no la actualiza, puede tener problemas de acceso.`,
  ACCOUNT_SWITCH_REFRESH_NOW: `Actualizar ahora`,
  ACCOUNT_SWITCH_REFRESH_LATER: `Actualizar más tarde`,
  MY_ACCOUNT: `Mi cuenta`,
  MY_ACCOUNT_SHORT: `Cuenta`,
  MY_PROBLEMS: `Mis problemas`,
  MY_ACTIONS: `Mis acciones`,
  MY_SENT_ACTIONS: `Mis acciones enviadas`,
  MY_ACTIONS_HINT: `Lista de acciones de las que es responsable.`,
  MY_SENT_ACTIONS_HINT: `Lista de acciones que ha creado y que han sido enviadas a otros equipos.`,
  USER_ACCOUNT: `Cuenta de usuario`,
  EMAIL_ADDRESS: `Dirección de email`,
  PHONE_NUMBER: `Número de teléfono`,
  CHANGE_MY_PASSWORD: `Modificar mi contraseña`,
  WELCOME_TO_SHIZEN: `¡Le damos la bienvenida a Shizen!`,
  DATA_USAGE_SUMMARY: `Para funcionar correctamente, Shizen recopila ciertos datos sobre usted (nombre, apellidos, dirección de email). Estos datos se almacenan en un entorno seguro. Además, la empresa Shizen nunca los difundirá públicamente ni comunicará a organismos terceros.`,
  DATA_USAGE_MY_ACCOUNT: `Puede modificar estos datos en cualquier momento desde el área "@:message.MY_ACCOUNT".`,
  DATA_USAGE_NAMES_TITLE: `Apellidos y nombre`,
  DATA_USAGE_NAMES: `Los apellidos y el nombre se utilizan para mostrar la lista de miembros de un equipo, la persona responsable de una acción o de una resolución de problema, un participante de una reunión...`,
  DATA_USAGE_EMAIL_TITLE: `Dirección de email`,
  DATA_USAGE_EMAIL: `La dirección de email permite restablecer la contraseña. Ciertas funciones pronto le permitirán recibir emails cuando un usuario modifique una ficha de problema o una acción.`,
  DATA_USAGE_PICTURE_TITLE: `Fotografía`,
  DATA_USAGE_PICTURE: `La fotografía se utiliza con los mismos fines que los apellidos y el nombre, para una vista previa más visual.`,
  DEFAULT_HOME_PAGE: `Página de inicio predeterminada (para sustituir el panel)`,
  FILTER_RADIO_ITEMS: `Filtrar los elementos siguientes`,
  SETTINGS_MEETINGS_SAVED_AUTOMATICALLY: `Los ajustes de las reuniones se guardan automáticamente.`,
  FILTER_MEETINGS: `Filtrar las reuniones`,
  NO_FILTER_SELECTED: `Ningún filtro seleccionado`,
  MEETING_N_STEPS: `Ninguna etapa | 1 etapa | {n} etapa`,
  CONFIG_ADMIN: `Config / Admin`,
  BOLD: `Negrita`,
  ITALIC: `Cursiva`,
  UNDERLINE: `Subrayado`,
  STRIKETHROUGH: `Resaltado`,
  HIGHLIGHT: `Destacado`,
  HEADING_1: `Título 1`,
  HEADING_2: `Título 2`,
  PARAGRAPH: `Párrafo`,
  BULLET_LIST: `Lista de viñetas`,
  NUMBERED_LIST: `Lista numerada`,
  CHECK_LIST: `Checklist`,
  BLOCKQUOTE: `Cita`,
  HORIZONTAL_LINE: `Línea horizontal`,
  CLEAR_FORMATTING: `Borrar el formato`,
  UNDO: `Deshacer`,
  REDO: `Rehacer`,
  BULLET_POINT: `•`,
  COMMA: `,`,
  STATS_OVERVIEW_TITLE: `Estadísticas de usuarios`,
  STATS_NODATA: `No hay datos disponibles.`,
  STATS_STATUS_ONLINE: `Conectado`,
  STATS_STATUS_OFFLINE: `Desconectado`,
  STATS_STATUS_OFFLINE_COMPANY: `No hay usuarios conectados`,
  STATS_STATUS_AFK: `Ausente`,
  STATS_STATUS_AFK_COMPANY: `Último usuario ausente`,
  SINCE: `durante`,
  OVERVIEW_CREATED_PB: `No se ha creado ningún problema | 1 problema creado | {n} problemas creados`,
  OVERVIEW_FINISHED_PB: `No problema completado | 1 problema completado | {n} problemas terminados`,
  CONNECTIONS: `Conexiones`,
  OVERVIEW_REFRESH: `Actualizar datos`,
  OVERVIEW_REFRESH_WARNING: `Por favor, actualice los datos para actualizar la información.`,
  LIST_OF_COMPANIES: `Lista de empresas`,
  LIST_OF_TEAMS: `Lista de equipos`,
  LIST_OF_USERS: `Lista de usuarios`,
  SUMMARY_STATS: `Resumen de las estadísticas`,
  COMPANIES: `Empresas`,
  CREATED_ACTIONS: `Creados`,
  CREATED_PROBLEMS: `Creados`,
  FINISHED_ACTIONS: `Terminados`,
  FINISHED_PROBLEMS: `Terminados`,
  SHORT_DAY: `d`,
  ONLINE: `Conectado`,
  ABSENT: `Ausente`,
  OFFLINE: `Fuera de linea`,
  COMPANY: `Compañía`,
  AVERAGE_CREATION_TIME: `Tiempo medio de creación`,
  REPORTED_ON_JIRA: `Informe en jira`,
  SHIZEN_STATS: `Estadísticas de Shizen`,
  // Charts messages
  CHART_CATEGORY_MARKETING: `Márketing`,
  CHART_CATEGORY_DEVELOPMENT: `Desarrollo`,
  CHART_CATEGORY_CUSTOMERSUCCESS: `Customer Success`,
  CHART_CATEGORY_PRODUCTLIFE: `Vida del producto`,
  CHARTS_CREATED_ACTIONS: `Número de acciones creadas`,
  CHARTS_FINISHED_ACTIONS: `Número de acciones completadas`,
  CHARTS_ACTIONS_UNIT: `acciones`,
  CHARTS_CREATED_PB: `Número de problemas creados`,
  CHARTS_FINISHED_PB: `Número de problemas completados`,
  CHARTS_PB_UNIT: `problemas`,
  CHARTS_FINISHED_MEETINGS: `Número de reuniones realizadas`,
  CHARTS_MEETINGS_UNIT: `reuniones`,
  CHARTS_TIME_CREATING_ACTION: `Hora de crear una acción`,
  CHARTS_TIME_CREATING_PB: `Hora de crear un problema`,
  CHARTS_BUGS_REPORTED: `Número de errores notificados`,
  CHARTS_BUGS_UNIT: `errores`,
  CHARTS_TASKS_REPORTED: `Número de tareas aplazadas`,
  CHARTS_TASKS_UNIT: `tareas`,
  CHARTS_TIME_ONLINE: `Tiempo conectado`,
  CHARTS_TIME_OFFLINE: `Tiempo de inactividad`,
  CHARTS_CONNECTION_FREQUENCY: `Frecuencia de conexión`,
  CHARTS_LOGIN_UNIT: `conexiónes`,
  COMPLETED_GW_SEE_PARTICIPANTS: `Participantes`,
  COMPLETED_GW_PARTICIPATING_TEAM: `Equipo participante`,
  COMPLETED_GW_NB_THIS_GW: `Participaciones en esta IT`,
  COMPLETED_GW_NB_ALL_GW: `Número total de IT realizadas`,
  COMPLETED_GW_EMPTY: `No se han definido participantes para esta IT.`,
  WAIT_INDICATORS_LOADED: `Por favor, espere hasta que se carguen los indicadores.`,
  ACTIONS_PER_CAUSE_MODAL_TITLE: `Acciones de la causa`,
  ADD_ACTION_PER_CAUSE: `Añadir una acción relacionada con esta causa`,
  NO_ACTION_PLAN: `Ningún plan de acción`,
  IMPACT_LOW: `Low`,
  IMPACT_MODERATE: `Moderate`,
  IMPACT_SIGNIFICANT: `Significant`,
  IMPACT_CRITICAL: `Critical`,
  IMPACT_DISPLAY: `{val} - {text}`,
  NO_SELECTION: `Ninguna selección`,
  // Rating Modal
  RATINGS: `Aviso`,
  RATE: `Nota`,
  GLOBAL_RATING_TITLE: `¿Una opinión sobre Shizen?`,
  RATING_TITLE: `Su opinión es importante para nosotros.`,
  GLOBAL_RATING_SUBTITLE_INTRO: `Recogemos los comentarios sobre los productos para mejorarlos y permitirnos conocer su opinión sobre las funccionalidades de Shizen.`,
  GLOBAL_RATING_SUBTITLE: `¿Recomendarías Shizen a tu séquito?`,
  I_DONT_RECOMMEND: `No recomiendo`,
  RATING_STATUS_0: `Muy difícil`,
  RATING_STATUS_1: `Difícil`,
  RATING_STATUS_2: `Normal`,
  RATING_STATUS_3: `Fácil`,
  RATING_STATUS_4: `Muy fácil`,
  RATING_SUCCESS_THANKS: `Gracias por su comentario.`,
  RATING_BUTTON_NEVER_AGAIN: `No me preguntes más`,
  RATING_NEVER_AGAIN_MESSAGE: `Ya no le pediremos su opinión sobre esta página o función.`,
  // Rating Modal messages by ID
  RATING_MESSAGE_1: `¿Qué opina de la facilidad para crear un problema?`,
  RATING_MESSAGE_2: `¿Qué opina de la facilidad para llenar un indicador?`,
  RATING_MESSAGE_3: `¿Qué opina de la facilidad para crear una acción?`,
  RATING_MESSAGE_4: `¿Qué opina de la facilidad para crear una reunión?`,
  RATING_MESSAGE_5: `¿Qué opina de la facilidad para dirigir una reunión?`,
  RATING_MESSAGE_6: `¿Qué opina de la facilidad para realizar una inspección sobre el terreno?`,
  // 7 is the global message defined in the rating-modal component itself
  RATING_MESSAGE_8: `¿Qué opina de la facilidad para crear una información?`,
  RATING_MESSAGE_9: `¿Qué opina de la facilidad de gestión de los indicadores?`,
  RATING_MESSAGE_10: `¿Qué opina de la facilidad para afrontar los problemas?`,
  RATING_MESSAGE_11: `¿Qué opina de la facilidad de gestión de las acciones?`,
  RATING_MESSAGE_12: `¿Qué opina de la facilidad para crear una página personalizable?`,
  // Excel exported categories
  RATING_EXPORT_BUTTON: `Exportar notas`,
  // Those categories below are generated from RatingController.php and are parsed in the exportRatingsToExcel function in rating-utils.js
  RATING_PROBLEM_CREATION: `Creación de un problema`,
  RATING_INDICATOR_INPUT: `Introducción de un indicador`,
  RATING_ACTION_CREATION: `Creación de una acción`,
  RATING_MEETING_CREATION: `Iniciar una reunión`,
  RATING_MEETING_LEAD: `Dirigir una reunión`,
  RATING_GEMBA_WALK_LEAD: `Producción de una IT`,
  RATING_GLOBAL: `Puntuación global`,
  RATING_INFORMATION_CLARITY: `Creación de las informaciónes`,
  RATING_INDICATOR_MANAGEMENT: `Gestión de los indicadores`,
  RATING_PROBLEM_MANAGEMENT: `Gestión de los problemas`,
  RATING_ACTION_MANAGEMENT: `Gestión de las acciones`,
  RATING_CONFIGURABLE_PAGE_CREATION: `Creación de una página personalizable`,
  VALUE: `Valor`,
  STEP_VALIDATION: `Validación de la etapa`,
  LAST_CONNECTION: `Última conexión en`,
  FIRST_CONNECTION: `Primera conexión en`,
  CREATED: `Creado el`,
  TEAM_NOT_FOUND: `Equipo no encontrado`,
  CANNOT_SAVE_TEAM_PARAMETERS: `No se ha podido guardar la configuración del equipo`,
  USER_NOT_FOUND: `Usuario no encontrado`,
  NOTHING_TO_UPDATE: `Nada que actualizar`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS: `Restringir el acceso a la configuración`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS_HINT: `Al marcar esta opción, sólo los usuarios especialmente autorizados podrán cambiar la configuración de sus equipos`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE: `Restringir la creación y actualización de problemas`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE_HINT: `Al marcar esta opción, sólo los usuarios especialmente autorizados podrán crear o actualizar un problema`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS: `Lista de campos del formulario del problema para los que debe generarse una notificación`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS_PLACEHOLDER: `Lista de campos separados por comas. Por ejemplo, fecha límite, descripción`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS_HINT: `Al rellenar esta opción se generará una notificación para cualquier cambio en el registro del problema. Si se deja en blanco, todos los campos generarán una notificación`,
  ERROR_UNAUTHORIZE: `No se permite`,
  EVENT: `Evento`,
  EVENTS: `Eventos`,
  N_EVENTS: `No evento | 1 evento | {nb} eventos`,
  GOT_IT: `Lo entiendo`,
  UPCOMING_EVENTS: `Próximos eventos`,
  SETTINGS_PROBLEMS_ADD_FIELDS: `Mostrar campos adicionales en la lista`,
  HIDE_ADDITIONAL_FIELDS: `Ocultar campos adicionales`,
  OFFLINE_MODE_ON: `Está en modo offline`,
  OFFLINE_MODE_SYNC: `Vuelve a conectarse`,
  OFFLINE_MODE_SLOW_REQUESTS: `La conexión a Internet tarda en llegar. ¿Quiere desconectarse?`,
  OFFLINE_MODE_TURN_ON: `Modo offline`,
  OFFLINE_MODE_PROMPT_OFF: `¿Quiere volver a conectarse?`,
  OFFLINE_MODE_PROMPT_OFF_NEED_SYNC: `Shizen tendrá que realizar una breve sincronización para enviar sus datos en línea.`,
  OFFLINE_MODE_SYNCING: `Shizen está sincronizando los siguientes datos en línea. Por favor, espere hasta que la sincronización termine, o haga clic en el botón de cancelar para permanecer offline.`,
  OFFLINE_MODE_SYNCING_OVER: `La sincronización ha terminado. Ahora puedes cerrar esta ventana y seguir utilizando Shizen online.`,
  OFFLINE_MODE_SYNCING_OVER_ERROR: `La sincronización se ha completado con errores. Por favor, asegúrese de que su dispositivo está conectado a Internet y vuelva a intentarlo.`,
  OFFLINE_PROBLEMS: `Problemas creados offline`,
  OFFLINE_ACTIONS: `Acciones creadas offline`,
  NETWORK_MGR_CREATE: `Creación`,
  NETWORK_MGR_UPDATE: `Modificación`,
  NETWORK_MGR_DELETE: `Eliminación`,
  NETWORK_MGR_NAME: `{type} : {dataType}`,
};

export default messages;
